/* eslint-disable */
(function
    webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory();
    else if (typeof define === 'function' && define.amd)
        define("SecureLS", [], factory);
    else if (typeof exports === 'object')
        exports["SecureLS"] = factory();
    else
        root["SecureLS"] = factory();
})(this, function () {
    return /******/ (function (modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if (installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
                /******/
            };
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
            /******/
        }
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
        /******/
    })
/************************************************************************/
/******/([
/* 0 */
/***/ function (module, exports, __webpack_require__) {

            'use strict';

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

            var _utils = __webpack_require__(1);

            var _utils2 = _interopRequireDefault(_utils);

            var _constants = __webpack_require__(2);

            var _constants2 = _interopRequireDefault(_constants);

            var _encUtf = __webpack_require__(8);

            var _encUtf2 = _interopRequireDefault(_encUtf);

            var _Base = __webpack_require__(9);

            var _Base2 = _interopRequireDefault(_Base);

            var _lzString = __webpack_require__(10);

            var _lzString2 = _interopRequireDefault(_lzString);

            var _aes = __webpack_require__(11);

            var _aes2 = _interopRequireDefault(_aes);

            var _tripledes = __webpack_require__(16);

            var _tripledes2 = _interopRequireDefault(_tripledes);

            var _rabbit = __webpack_require__(17);

            var _rabbit2 = _interopRequireDefault(_rabbit);

            var _rc = __webpack_require__(18);

            var _rc2 = _interopRequireDefault(_rc);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var SecureLS = function () {
                function SecureLS(config) {
                    _classCallCheck(this, SecureLS);

                    config = config || {};
                    this._name = 'secure-ls';
                    this.utils = _utils2.default;
                    this.constants = _constants2.default;
                    this.Base64 = _Base2.default;
                    this.LZString = _lzString2.default;
                    this.AES = _aes2.default;
                    this.DES = _tripledes2.default;
                    this.RABBIT = _rabbit2.default;
                    this.RC4 = _rc2.default;
                    this.enc = _encUtf2.default;

                    this.config = {
                        isCompression: true,
                        encodingType: _constants2.default.EncrytionTypes.BASE64,
                        encryptionSecret: config.encryptionSecret,
                        encryptionNamespace: config.encryptionNamespace
                    };
                    this.config.isCompression = typeof config.isCompression !== 'undefined' ? config.isCompression : true;
                    this.config.encodingType = typeof config.encodingType !== 'undefined' || config.encodingType === '' ? config.encodingType.toLowerCase() : _constants2.default.EncrytionTypes.BASE64;

                    this.ls = sessionStorage;
                    // this.ls = localStorage;
                    this.init();
                }

                _createClass(SecureLS, [{
                    key: 'init',
                    value: function init() {
                        var metaData = this.getMetaData();

                        this.WarningEnum = this.constants.WarningEnum;
                        this.WarningTypes = this.constants.WarningTypes;
                        this.EncrytionTypes = this.constants.EncrytionTypes;

                        this._isBase64 = this._isBase64EncryptionType();
                        this._isAES = this._isAESEncryptionType();
                        this._isDES = this._isDESEncryptionType();
                        this._isRabbit = this._isRabbitEncryptionType();
                        this._isRC4 = this._isRC4EncryptionType();
                        this._isCompression = this._isDataCompressionEnabled();

                        // fill the already present keys to the list of keys being used by secure-ls
                        this.utils.allKeys = metaData.keys || this.resetAllKeys();
                    }
                }, {
                    key: '_isBase64EncryptionType',
                    value: function _isBase64EncryptionType() {
                        return _Base2.default && (typeof this.config.encodingType === 'undefined' || this.config.encodingType === this.constants.EncrytionTypes.BASE64);
                    }
                }, {
                    key: '_isAESEncryptionType',
                    value: function _isAESEncryptionType() {
                        return _aes2.default && this.config.encodingType === this.constants.EncrytionTypes.AES;
                    }
                }, {
                    key: '_isDESEncryptionType',
                    value: function _isDESEncryptionType() {
                        return _tripledes2.default && this.config.encodingType === this.constants.EncrytionTypes.DES;
                    }
                }, {
                    key: '_isRabbitEncryptionType',
                    value: function _isRabbitEncryptionType() {
                        return _rabbit2.default && this.config.encodingType === this.constants.EncrytionTypes.RABBIT;
                    }
                }, {
                    key: '_isRC4EncryptionType',
                    value: function _isRC4EncryptionType() {
                        return _rc2.default && this.config.encodingType === this.constants.EncrytionTypes.RC4;
                    }
                }, {
                    key: '_isDataCompressionEnabled',
                    value: function _isDataCompressionEnabled() {
                        return this.config.isCompression;
                    }
                }, {
                    key: 'getEncryptionSecret',
                    value: function getEncryptionSecret(key) {
                        var metaData = this.getMetaData();
                        var obj = this.utils.getObjectFromKey(metaData.keys, key);

                        if (!obj) {
                            return;
                        }

                        if (this._isAES || this._isDES || this._isRabbit || this._isRC4) {
                            if (typeof this.config.encryptionSecret === 'undefined') {
                                this.utils.encryptionSecret = obj.s;

                                if (!this.utils.encryptionSecret) {
                                    this.utils.encryptionSecret = this.utils.generateSecretKey();
                                    this.setMetaData();
                                }
                            } else {
                                this.utils.encryptionSecret = this.config.encryptionSecret || obj.s || '';
                            }
                        }
                    }
                }, {
                    key: 'get',
                    value: function get(key, isAllKeysData) {
                        var decodedData = '',
                            jsonData = '',
                            deCompressedData = void 0,
                            bytes = void 0,
                            data = void 0;

                        if (!this.utils.is(key)) {
                            this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED);
                            return jsonData;
                        }

                        data = this.getDataFromLocalStorage(key);

                        if (!data) {
                            return jsonData;
                        }

                        deCompressedData = data; // saves else
                        if (this._isCompression || isAllKeysData) {
                            // meta data always compressed
                            deCompressedData = _lzString2.default.decompressFromUTF16(data);
                        }

                        decodedData = deCompressedData; // saves else
                        if (this._isBase64 || isAllKeysData) {
                            // meta data always Base64
                            decodedData = _Base2.default.decode(deCompressedData);
                        } else {
                            this.getEncryptionSecret(key);
                            if (this._isAES) {
                                bytes = _aes2.default.decrypt(deCompressedData.toString(), this.utils.encryptionSecret);
                            } else if (this._isDES) {
                                bytes = _tripledes2.default.decrypt(deCompressedData.toString(), this.utils.encryptionSecret);
                            } else if (this._isRabbit) {
                                bytes = _rabbit2.default.decrypt(deCompressedData.toString(), this.utils.encryptionSecret);
                            } else if (this._isRC4) {
                                bytes = _rc2.default.decrypt(deCompressedData.toString(), this.utils.encryptionSecret);
                            }

                            if (bytes) {
                                decodedData = bytes.toString(_encUtf2.default._Utf8);
                            }
                        }

                        try {
                            jsonData = JSON.parse(decodedData);
                        } catch (e) {
                            throw new Error('Could not parse JSON');
                        }

                        return jsonData;
                    }
                }, {
                    key: 'getDataFromLocalStorage',
                    value: function getDataFromLocalStorage(key) {
                        return this.ls.getItem(key, true);
                    }
                }, {
                    key: 'getAllKeys',
                    value: function getAllKeys() {
                        var data = this.getMetaData();

                        return this.utils.extractKeyNames(data) || [];
                    }
                }, {
                    key: 'set',
                    value: function set(key, data) {
                        var dataToStore = '';

                        if (!this.utils.is(key)) {
                            this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED);
                            return;
                        }

                        this.getEncryptionSecret(key);

                        // add key(s) to Array if not already added, only for keys other than meta key
                        if (!(String(key) === String(this.utils.metaKey))) {
                            if (!this.utils.isKeyPresent(key)) {
                                this.utils.addToKeysList(key);
                                this.setMetaData();
                            }
                        }

                        dataToStore = this.processData(data);
                        // Store the data to localStorage
                        this.setDataToLocalStorage(key, dataToStore);
                    }
                }, {
                    key: 'setDataToLocalStorage',
                    value: function setDataToLocalStorage(key, data) {
                        this.ls.setItem(key, data);
                    }
                }, {
                    key: 'remove',
                    value: function remove(key) {
                        if (!this.utils.is(key)) {
                            this.utils.warn(this.WarningEnum.KEY_NOT_PROVIDED);
                            return;
                        }

                        if (key === this.utils.metaKey && this.getAllKeys().length) {
                            this.utils.warn(this.WarningEnum.META_KEY_REMOVE);
                            return;
                        }

                        if (this.utils.isKeyPresent(key)) {
                            this.utils.removeFromKeysList(key);
                            this.setMetaData();
                        }
                        this.ls.removeItem(key);
                    }
                }, {
                    key: 'removeAll',
                    value: function removeAll() {
                        var keys = void 0,
                            i = void 0;

                        keys = this.getAllKeys();
                        for (i = 0; i < keys.length; i++) {
                            this.ls.removeItem(keys[i]);
                        }
                        this.ls.removeItem(this.utils.metaKey);

                        this.resetAllKeys();
                    }
                }, {
                    key: 'clear',
                    value: function clear() {
                        this.ls.clear();
                        this.resetAllKeys();
                    }
                }, {
                    key: 'resetAllKeys',
                    value: function resetAllKeys() {
                        this.utils.allKeys = [];
                        return [];
                    }
                }, {
                    key: 'processData',
                    value: function processData(data, isAllKeysData) {
                        if (data === null || data === undefined || data === '') {
                            return '';
                        }

                        var jsonData = void 0,
                            encodedData = void 0,
                            compressedData = void 0;

                        try {
                            jsonData = JSON.stringify(data);
                        } catch (e) {
                            throw new Error('Could not stringify data.');
                        }

                        // Encode Based on encoding type
                        // If not set, default to Base64 for securing data
                        encodedData = jsonData;
                        if (this._isBase64 || isAllKeysData) {
                            encodedData = _Base2.default.encode(jsonData);
                        } else {
                            if (this._isAES) {
                                encodedData = _aes2.default.encrypt(jsonData, this.utils.encryptionSecret);
                            } else if (this._isDES) {
                                encodedData = _tripledes2.default.encrypt(jsonData, this.utils.encryptionSecret);
                            } else if (this._isRabbit) {
                                encodedData = _rabbit2.default.encrypt(jsonData, this.utils.encryptionSecret);
                            } else if (this._isRC4) {
                                encodedData = _rc2.default.encrypt(jsonData, this.utils.encryptionSecret);
                            }

                            encodedData = encodedData && encodedData.toString();
                        }

                        // Compress data if set to true
                        compressedData = encodedData;
                        if (this._isCompression || isAllKeysData) {
                            compressedData = _lzString2.default.compressToUTF16(encodedData);
                        }

                        return compressedData;
                    }
                }, {
                    key: 'setMetaData',
                    value: function setMetaData() {
                        var dataToStore = this.processData({
                            keys: this.utils.allKeys
                        }, true);

                        // Store the data to localStorage
                        this.setDataToLocalStorage(this.getMetaKey(), dataToStore);
                    }
                }, {
                    key: 'getMetaData',
                    value: function getMetaData() {
                        return this.get(this.getMetaKey(), true) || {};
                    }
                }, {
                    key: 'getMetaKey',
                    value: function getMetaKey() {
                        return this.utils.metaKey + (this.config.encryptionNamespace ? '__' + this.config.encryptionNamespace : '');
                    }
                }]);

                return SecureLS;
            }();

            exports.default = SecureLS;
            ;
            module.exports = exports['default'];

            /***/
        },
/* 1 */
/***/ function (module, exports, __webpack_require__) {

            'use strict';

            var _constants = __webpack_require__(2);

            var _constants2 = _interopRequireDefault(_constants);

            var _WordArray = __webpack_require__(3);

            var _WordArray2 = _interopRequireDefault(_WordArray);

            var _pbkdf = __webpack_require__(4);

            var _pbkdf2 = _interopRequireDefault(_pbkdf);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            var utils = {
                metaKey: '_secure__ls__metadata',
                encryptionSecret: '',
                secretPhrase: 's3cr3t$#@135^&*246',
                allKeys: [],
                is: function is(key) {
                    if (key) {
                        return true;
                    }
                    return false;
                },
                warn: function warn(reason) {
                    reason = reason ? reason : _constants2.default.WarningEnum.DEFAULT_TEXT;
                    console.warn(_constants2.default.WarningTypes[reason]);
                },
                generateSecretKey: function generateSecretKey() {
                    var salt = _WordArray2.default.random(128 / 8);
                    var key128Bits = (0, _pbkdf2.default)(this.secretPhrase, salt, { keySize: 128 / 32 });

                    return key128Bits && key128Bits.toString();
                },
                getObjectFromKey: function getObjectFromKey(data, key) {
                    if (!data || !data.length) {
                        return {};
                    }

                    var i = void 0,
                        obj = {};

                    for (i = 0; i < data.length; i++) {
                        if (data[i].k === key) {
                            obj = data[i];
                            break;
                        }
                    }

                    return obj;
                },
                extractKeyNames: function extractKeyNames(data) {
                    if (!data || !data.keys || !data.keys.length) {
                        return [];
                    }

                    return data.keys.map(function (keyData) {
                        return keyData.k;
                    });
                },
                getAllKeys: function getAllKeys() {
                    return this.allKeys;
                },
                isKeyPresent: function isKeyPresent(key) {
                    var isKeyAlreadyPresent = false;

                    for (var i = 0; i < this.allKeys.length; i++) {
                        if (String(this.allKeys[i].k) === String(key)) {
                            isKeyAlreadyPresent = true; // found
                            break;
                        }
                    }

                    return isKeyAlreadyPresent;
                },
                addToKeysList: function addToKeysList(key) {
                    this.allKeys.push({
                        k: key,
                        s: this.encryptionSecret
                    });
                },
                removeFromKeysList: function removeFromKeysList(key) {
                    var i = void 0,
                        index = -1;

                    for (i = 0; i < this.allKeys.length; i++) {
                        if (this.allKeys[i].k === key) {
                            index = i;
                            break;
                        }
                    }
                    if (index !== -1) {
                        this.allKeys.splice(index, 1);
                    }
                    return index;
                }
            };

            module.exports = utils;

            /***/
        },
/* 2 */
/***/ function (module, exports) {

            'use strict';

            var WarningEnum = {
                KEY_NOT_PROVIDED: 'keyNotProvided',
                META_KEY_REMOVE: 'metaKeyRemove',
                DEFAULT_TEXT: 'defaultText'
            };

            var WarningTypes = {};

            WarningTypes[WarningEnum.KEY_NOT_PROVIDED] = 'Secure LS: Key not provided. Aborting operation!';
            WarningTypes[WarningEnum.META_KEY_REMOVE] = 'Secure LS: Meta key can not be removed\nunless all keys created by Secure LS are removed!';
            WarningTypes[WarningEnum.DEFAULT_TEXT] = 'Unexpected output';

            var constants = {
                WarningEnum: WarningEnum,
                WarningTypes: WarningTypes,
                EncrytionTypes: {
                    BASE64: 'base64',
                    AES: 'aes',
                    DES: 'des',
                    RABBIT: 'rabbit',
                    RC4: 'rc4'
                }
            };

            module.exports = constants;

            /***/
        },
/* 3 */
/***/ function (module, exports) {

            "use strict";

            /*
             ES6 compatible port of CryptoJS - WordArray for PBKDF2 password key generation
        	
             Source: https://github.com/brix/crypto-js
             LICENSE: MIT
             */

            var CryptoJSWordArray = {};

            CryptoJSWordArray.random = function (nBytes) {
                var words = [];
                var r = function r(mw) {
                    var mz = 0x3ade68b1;
                    var mask = 0xffffffff;

                    return function () {
                        mz = 0x9069 * (mz & 0xFFFF) + (mz >> 0x10) & mask;
                        mw = 0x4650 * (mw & 0xFFFF) + (mw >> 0x10) & mask;
                        var result = (mz << 0x10) + mw & mask;

                        result /= 0x100000000;
                        result += 0.5;
                        return result * (Math.random() > 0.5 ? 1 : -1);
                    };
                };

                for (var i = 0, rcache; i < nBytes; i += 4) {
                    var _r = r((rcache || Math.random()) * 0x100000000);

                    rcache = _r() * 0x3ade67b7;
                    words.push(_r() * 0x100000000 | 0);
                }

                return new this.Set(words, nBytes);
            };

            CryptoJSWordArray.Set = function (words, sigBytes) {
                words = this.words = words || [];

                if (sigBytes !== undefined) {
                    this.sigBytes = sigBytes;
                } else {
                    this.sigBytes = words.length * 8;
                }
            };

            module.exports = CryptoJSWordArray;

            /***/
        },
/* 4 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(6), __webpack_require__(7));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./sha1", "./hmac"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var C_algo = C.algo;
                    var SHA1 = C_algo.SHA1;
                    var HMAC = C_algo.HMAC;

                    /**
                     * Password-Based Key Derivation Function 2 algorithm.
                     */
                    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                         * @property {Hasher} hasher The hasher to use. Default: SHA1
                         * @property {number} iterations The number of iterations to perform. Default: 1
                         */
                        cfg: Base.extend({
                            keySize: 128 / 32,
                            hasher: SHA1,
                            iterations: 1
                        }),

                        /**
                         * Initializes a newly created key derivation function.
                         *
                         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                         *
                         * @example
                         *
                         *     var kdf = CryptoJS.algo.PBKDF2.create();
                         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
                         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
                         */
                        init: function (cfg) {
                            this.cfg = this.cfg.extend(cfg);
                        },

                        /**
                         * Computes the Password-Based Key Derivation Function 2.
                         *
                         * @param {WordArray|string} password The password.
                         * @param {WordArray|string} salt A salt.
                         *
                         * @return {WordArray} The derived key.
                         *
                         * @example
                         *
                         *     var key = kdf.compute(password, salt);
                         */
                        compute: function (password, salt) {
                            // Shortcut
                            var cfg = this.cfg;

                            // Init HMAC
                            var hmac = HMAC.create(cfg.hasher, password);

                            // Initial values
                            var derivedKey = WordArray.create();
                            var blockIndex = WordArray.create([0x00000001]);

                            // Shortcuts
                            var derivedKeyWords = derivedKey.words;
                            var blockIndexWords = blockIndex.words;
                            var keySize = cfg.keySize;
                            var iterations = cfg.iterations;

                            // Generate key
                            while (derivedKeyWords.length < keySize) {
                                var block = hmac.update(salt).finalize(blockIndex);
                                hmac.reset();

                                // Shortcuts
                                var blockWords = block.words;
                                var blockWordsLength = blockWords.length;

                                // Iterations
                                var intermediate = block;
                                for (var i = 1; i < iterations; i++) {
                                    intermediate = hmac.finalize(intermediate);
                                    hmac.reset();

                                    // Shortcut
                                    var intermediateWords = intermediate.words;

                                    // XOR intermediate with block
                                    for (var j = 0; j < blockWordsLength; j++) {
                                        blockWords[j] ^= intermediateWords[j];
                                    }
                                }

                                derivedKey.concat(block);
                                blockIndexWords[0]++;
                            }
                            derivedKey.sigBytes = keySize * 4;

                            return derivedKey;
                        }
                    });

                    /**
                     * Computes the Password-Based Key Derivation Function 2.
                     *
                     * @param {WordArray|string} password The password.
                     * @param {WordArray|string} salt A salt.
                     * @param {Object} cfg (Optional) The configuration options to use for this computation.
                     *
                     * @return {WordArray} The derived key.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var key = CryptoJS.PBKDF2(password, salt);
                     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
                     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
                     */
                    C.PBKDF2 = function (password, salt, cfg) {
                        return PBKDF2.create(cfg).compute(password, salt);
                    };
                }());


                return CryptoJS.PBKDF2;

            }));

            /***/
        },
/* 5 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory();
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define([], factory);
                }
                else {
                    // Global (browser)
                    root.CryptoJS = factory();
                }
            }(this, function () {

                /**
                 * CryptoJS core components.
                 */
                var CryptoJS = CryptoJS || (function (Math, undefined) {
                    /*
                     * Local polyfil of Object.create
                     */
                    var create = Object.create || (function () {
                        function F() { };

                        return function (obj) {
                            var subtype;

                            F.prototype = obj;

                            subtype = new F();

                            F.prototype = null;

                            return subtype;
                        };
                    }())

                    /**
                     * CryptoJS namespace.
                     */
                    var C = {};

                    /**
                     * Library namespace.
                     */
                    var C_lib = C.lib = {};

                    /**
                     * Base object for prototypal inheritance.
                     */
                    var Base = C_lib.Base = (function () {


                        return {
                            /**
                             * Creates a new object that inherits from this object.
                             *
                             * @param {Object} overrides Properties to copy into the new object.
                             *
                             * @return {Object} The new object.
                             *
                             * @static
                             *
                             * @example
                             *
                             *     var MyType = CryptoJS.lib.Base.extend({
                             *         field: 'value',
                             *
                             *         method: function () {
                             *         }
                             *     });
                             */
                            extend: function (overrides) {
                                // Spawn
                                var subtype = create(this);

                                // Augment
                                if (overrides) {
                                    subtype.mixIn(overrides);
                                }

                                // Create default initializer
                                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
                                    subtype.init = function () {
                                        subtype.$super.init.apply(this, arguments);
                                    };
                                }

                                // Initializer's prototype is the subtype object
                                subtype.init.prototype = subtype;

                                // Reference supertype
                                subtype.$super = this;

                                return subtype;
                            },

                            /**
                             * Extends this object and runs the init method.
                             * Arguments to create() will be passed to init().
                             *
                             * @return {Object} The new object.
                             *
                             * @static
                             *
                             * @example
                             *
                             *     var instance = MyType.create();
                             */
                            create: function () {
                                var instance = this.extend();
                                instance.init.apply(instance, arguments);

                                return instance;
                            },

                            /**
                             * Initializes a newly created object.
                             * Override this method to add some logic when your objects are created.
                             *
                             * @example
                             *
                             *     var MyType = CryptoJS.lib.Base.extend({
                             *         init: function () {
                             *             // ...
                             *         }
                             *     });
                             */
                            init: function () {
                            },

                            /**
                             * Copies properties into this object.
                             *
                             * @param {Object} properties The properties to mix in.
                             *
                             * @example
                             *
                             *     MyType.mixIn({
                             *         field: 'value'
                             *     });
                             */
                            mixIn: function (properties) {
                                for (var propertyName in properties) {
                                    if (properties.hasOwnProperty(propertyName)) {
                                        this[propertyName] = properties[propertyName];
                                    }
                                }

                                // IE won't copy toString using the loop above
                                if (properties.hasOwnProperty('toString')) {
                                    this.toString = properties.toString;
                                }
                            },

                            /**
                             * Creates a copy of this object.
                             *
                             * @return {Object} The clone.
                             *
                             * @example
                             *
                             *     var clone = instance.clone();
                             */
                            clone: function () {
                                return this.init.prototype.extend(this);
                            }
                        };
                    }());

                    /**
                     * An array of 32-bit words.
                     *
                     * @property {Array} words The array of 32-bit words.
                     * @property {number} sigBytes The number of significant bytes in this word array.
                     */
                    var WordArray = C_lib.WordArray = Base.extend({
                        /**
                         * Initializes a newly created word array.
                         *
                         * @param {Array} words (Optional) An array of 32-bit words.
                         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.lib.WordArray.create();
                         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
                         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
                         */
                        init: function (words, sigBytes) {
                            words = this.words = words || [];

                            if (sigBytes != undefined) {
                                this.sigBytes = sigBytes;
                            } else {
                                this.sigBytes = words.length * 4;
                            }
                        },

                        /**
                         * Converts this word array to a string.
                         *
                         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
                         *
                         * @return {string} The stringified word array.
                         *
                         * @example
                         *
                         *     var string = wordArray + '';
                         *     var string = wordArray.toString();
                         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
                         */
                        toString: function (encoder) {
                            return (encoder || Hex).stringify(this);
                        },

                        /**
                         * Concatenates a word array to this word array.
                         *
                         * @param {WordArray} wordArray The word array to append.
                         *
                         * @return {WordArray} This word array.
                         *
                         * @example
                         *
                         *     wordArray1.concat(wordArray2);
                         */
                        concat: function (wordArray) {
                            // Shortcuts
                            var thisWords = this.words;
                            var thatWords = wordArray.words;
                            var thisSigBytes = this.sigBytes;
                            var thatSigBytes = wordArray.sigBytes;

                            // Clamp excess bits
                            this.clamp();

                            // Concat
                            if (thisSigBytes % 4) {
                                // Copy one byte at a time
                                for (var i = 0; i < thatSigBytes; i++) {
                                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
                                }
                            } else {
                                // Copy one word at a time
                                for (var i = 0; i < thatSigBytes; i += 4) {
                                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
                                }
                            }
                            this.sigBytes += thatSigBytes;

                            // Chainable
                            return this;
                        },

                        /**
                         * Removes insignificant bits.
                         *
                         * @example
                         *
                         *     wordArray.clamp();
                         */
                        clamp: function () {
                            // Shortcuts
                            var words = this.words;
                            var sigBytes = this.sigBytes;

                            // Clamp
                            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
                            words.length = Math.ceil(sigBytes / 4);
                        },

                        /**
                         * Creates a copy of this word array.
                         *
                         * @return {WordArray} The clone.
                         *
                         * @example
                         *
                         *     var clone = wordArray.clone();
                         */
                        clone: function () {
                            var clone = Base.clone.call(this);
                            clone.words = this.words.slice(0);

                            return clone;
                        },

                        /**
                         * Creates a word array filled with random bytes.
                         *
                         * @param {number} nBytes The number of random bytes to generate.
                         *
                         * @return {WordArray} The random word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.lib.WordArray.random(16);
                         */
                        random: function (nBytes) {
                            var words = [];

                            var r = (function (m_w) {
                                var m_w = m_w;
                                var m_z = 0x3ade68b1;
                                var mask = 0xffffffff;

                                return function () {
                                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
                                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
                                    var result = ((m_z << 0x10) + m_w) & mask;
                                    result /= 0x100000000;
                                    result += 0.5;
                                    return result * (Math.random() > .5 ? 1 : -1);
                                }
                            });

                            for (var i = 0, rcache; i < nBytes; i += 4) {
                                var _r = r((rcache || Math.random()) * 0x100000000);

                                rcache = _r() * 0x3ade67b7;
                                words.push((_r() * 0x100000000) | 0);
                            }

                            return new WordArray.init(words, nBytes);
                        }
                    });

                    /**
                     * Encoder namespace.
                     */
                    var C_enc = C.enc = {};

                    /**
                     * Hex encoding strategy.
                     */
                    var Hex = C_enc.Hex = {
                        /**
                         * Converts a word array to a hex string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The hex string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;

                            // Convert
                            var hexChars = [];
                            for (var i = 0; i < sigBytes; i++) {
                                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                                hexChars.push((bite >>> 4).toString(16));
                                hexChars.push((bite & 0x0f).toString(16));
                            }

                            return hexChars.join('');
                        },

                        /**
                         * Converts a hex string to a word array.
                         *
                         * @param {string} hexStr The hex string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
                         */
                        parse: function (hexStr) {
                            // Shortcut
                            var hexStrLength = hexStr.length;

                            // Convert
                            var words = [];
                            for (var i = 0; i < hexStrLength; i += 2) {
                                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
                            }

                            return new WordArray.init(words, hexStrLength / 2);
                        }
                    };

                    /**
                     * Latin1 encoding strategy.
                     */
                    var Latin1 = C_enc.Latin1 = {
                        /**
                         * Converts a word array to a Latin1 string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The Latin1 string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;

                            // Convert
                            var latin1Chars = [];
                            for (var i = 0; i < sigBytes; i++) {
                                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                                latin1Chars.push(String.fromCharCode(bite));
                            }

                            return latin1Chars.join('');
                        },

                        /**
                         * Converts a Latin1 string to a word array.
                         *
                         * @param {string} latin1Str The Latin1 string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
                         */
                        parse: function (latin1Str) {
                            // Shortcut
                            var latin1StrLength = latin1Str.length;

                            // Convert
                            var words = [];
                            for (var i = 0; i < latin1StrLength; i++) {
                                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
                            }

                            return new WordArray.init(words, latin1StrLength);
                        }
                    };

                    /**
                     * UTF-8 encoding strategy.
                     */
                    var Utf8 = C_enc.Utf8 = {
                        /**
                         * Converts a word array to a UTF-8 string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The UTF-8 string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                            try {
                                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                            } catch (e) {
                                throw new Error('Malformed UTF-8 data');
                            }
                        },

                        /**
                         * Converts a UTF-8 string to a word array.
                         *
                         * @param {string} utf8Str The UTF-8 string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
                         */
                        parse: function (utf8Str) {
                            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
                        }
                    };

                    /**
                     * Abstract buffered block algorithm template.
                     *
                     * The property blockSize must be implemented in a concrete subtype.
                     *
                     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
                     */
                    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
                        /**
                         * Resets this block algorithm's data buffer to its initial state.
                         *
                         * @example
                         *
                         *     bufferedBlockAlgorithm.reset();
                         */
                        reset: function () {
                            // Initial values
                            this._data = new WordArray.init();
                            this._nDataBytes = 0;
                        },

                        /**
                         * Adds new data to this block algorithm's buffer.
                         *
                         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
                         *
                         * @example
                         *
                         *     bufferedBlockAlgorithm._append('data');
                         *     bufferedBlockAlgorithm._append(wordArray);
                         */
                        _append: function (data) {
                            // Convert string to WordArray, else assume WordArray already
                            if (typeof data == 'string') {
                                data = Utf8.parse(data);
                            }

                            // Append
                            this._data.concat(data);
                            this._nDataBytes += data.sigBytes;
                        },

                        /**
                         * Processes available data blocks.
                         *
                         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
                         *
                         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
                         *
                         * @return {WordArray} The processed data.
                         *
                         * @example
                         *
                         *     var processedData = bufferedBlockAlgorithm._process();
                         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
                         */
                        _process: function (doFlush) {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var dataSigBytes = data.sigBytes;
                            var blockSize = this.blockSize;
                            var blockSizeBytes = blockSize * 4;

                            // Count blocks ready
                            var nBlocksReady = dataSigBytes / blockSizeBytes;
                            if (doFlush) {
                                // Round up to include partial blocks
                                nBlocksReady = Math.ceil(nBlocksReady);
                            } else {
                                // Round down to include only full blocks,
                                // less the number of blocks that must remain in the buffer
                                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
                            }

                            // Count words ready
                            var nWordsReady = nBlocksReady * blockSize;

                            // Count bytes ready
                            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

                            // Process blocks
                            if (nWordsReady) {
                                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                                    // Perform concrete-algorithm logic
                                    this._doProcessBlock(dataWords, offset);
                                }

                                // Remove processed words
                                var processedWords = dataWords.splice(0, nWordsReady);
                                data.sigBytes -= nBytesReady;
                            }

                            // Return processed words
                            return new WordArray.init(processedWords, nBytesReady);
                        },

                        /**
                         * Creates a copy of this object.
                         *
                         * @return {Object} The clone.
                         *
                         * @example
                         *
                         *     var clone = bufferedBlockAlgorithm.clone();
                         */
                        clone: function () {
                            var clone = Base.clone.call(this);
                            clone._data = this._data.clone();

                            return clone;
                        },

                        _minBufferSize: 0
                    });

                    /**
                     * Abstract hasher template.
                     *
                     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
                     */
                    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
                        /**
                         * Configuration options.
                         */
                        cfg: Base.extend(),

                        /**
                         * Initializes a newly created hasher.
                         *
                         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
                         *
                         * @example
                         *
                         *     var hasher = CryptoJS.algo.SHA256.create();
                         */
                        init: function (cfg) {
                            // Apply config defaults
                            this.cfg = this.cfg.extend(cfg);

                            // Set initial values
                            this.reset();
                        },

                        /**
                         * Resets this hasher to its initial state.
                         *
                         * @example
                         *
                         *     hasher.reset();
                         */
                        reset: function () {
                            // Reset data buffer
                            BufferedBlockAlgorithm.reset.call(this);

                            // Perform concrete-hasher logic
                            this._doReset();
                        },

                        /**
                         * Updates this hasher with a message.
                         *
                         * @param {WordArray|string} messageUpdate The message to append.
                         *
                         * @return {Hasher} This hasher.
                         *
                         * @example
                         *
                         *     hasher.update('message');
                         *     hasher.update(wordArray);
                         */
                        update: function (messageUpdate) {
                            // Append
                            this._append(messageUpdate);

                            // Update the hash
                            this._process();

                            // Chainable
                            return this;
                        },

                        /**
                         * Finalizes the hash computation.
                         * Note that the finalize operation is effectively a destructive, read-once operation.
                         *
                         * @param {WordArray|string} messageUpdate (Optional) A final message update.
                         *
                         * @return {WordArray} The hash.
                         *
                         * @example
                         *
                         *     var hash = hasher.finalize();
                         *     var hash = hasher.finalize('message');
                         *     var hash = hasher.finalize(wordArray);
                         */
                        finalize: function (messageUpdate) {
                            // Final message update
                            if (messageUpdate) {
                                this._append(messageUpdate);
                            }

                            // Perform concrete-hasher logic
                            var hash = this._doFinalize();

                            return hash;
                        },

                        blockSize: 512 / 32,

                        /**
                         * Creates a shortcut function to a hasher's object interface.
                         *
                         * @param {Hasher} hasher The hasher to create a helper for.
                         *
                         * @return {Function} The shortcut function.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
                         */
                        _createHelper: function (hasher) {
                            return function (message, cfg) {
                                return new hasher.init(cfg).finalize(message);
                            };
                        },

                        /**
                         * Creates a shortcut function to the HMAC's object interface.
                         *
                         * @param {Hasher} hasher The hasher to use in this HMAC helper.
                         *
                         * @return {Function} The shortcut function.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
                         */
                        _createHmacHelper: function (hasher) {
                            return function (message, key) {
                                return new C_algo.HMAC.init(hasher, key).finalize(message);
                            };
                        }
                    });

                    /**
                     * Algorithm namespace.
                     */
                    var C_algo = C.algo = {};

                    return C;
                }(Math));


                return CryptoJS;

            }));

            /***/
        },
/* 6 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;

                    // Reusable object
                    var W = [];

                    /**
                     * SHA-1 hash algorithm.
                     */
                    var SHA1 = C_algo.SHA1 = Hasher.extend({
                        _doReset: function () {
                            this._hash = new WordArray.init([
                                0x67452301, 0xefcdab89,
                                0x98badcfe, 0x10325476,
                                0xc3d2e1f0
                            ]);
                        },

                        _doProcessBlock: function (M, offset) {
                            // Shortcut
                            var H = this._hash.words;

                            // Working variables
                            var a = H[0];
                            var b = H[1];
                            var c = H[2];
                            var d = H[3];
                            var e = H[4];

                            // Computation
                            for (var i = 0; i < 80; i++) {
                                if (i < 16) {
                                    W[i] = M[offset + i] | 0;
                                } else {
                                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                                    W[i] = (n << 1) | (n >>> 31);
                                }

                                var t = ((a << 5) | (a >>> 27)) + e + W[i];
                                if (i < 20) {
                                    t += ((b & c) | (~b & d)) + 0x5a827999;
                                } else if (i < 40) {
                                    t += (b ^ c ^ d) + 0x6ed9eba1;
                                } else if (i < 60) {
                                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
                                } else /* if (i < 80) */ {
                                    t += (b ^ c ^ d) - 0x359d3e2a;
                                }

                                e = d;
                                d = c;
                                c = (b << 30) | (b >>> 2);
                                b = a;
                                a = t;
                            }

                            // Intermediate hash value
                            H[0] = (H[0] + a) | 0;
                            H[1] = (H[1] + b) | 0;
                            H[2] = (H[2] + c) | 0;
                            H[3] = (H[3] + d) | 0;
                            H[4] = (H[4] + e) | 0;
                        },

                        _doFinalize: function () {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;

                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;

                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
                            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
                            data.sigBytes = dataWords.length * 4;

                            // Hash final blocks
                            this._process();

                            // Return final computed hash
                            return this._hash;
                        },

                        clone: function () {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();

                            return clone;
                        }
                    });

                    /**
                     * Shortcut function to the hasher's object interface.
                     *
                     * @param {WordArray|string} message The message to hash.
                     *
                     * @return {WordArray} The hash.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hash = CryptoJS.SHA1('message');
                     *     var hash = CryptoJS.SHA1(wordArray);
                     */
                    C.SHA1 = Hasher._createHelper(SHA1);

                    /**
                     * Shortcut function to the HMAC's object interface.
                     *
                     * @param {WordArray|string} message The message to hash.
                     * @param {WordArray|string} key The secret key.
                     *
                     * @return {WordArray} The HMAC.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hmac = CryptoJS.HmacSHA1(message, key);
                     */
                    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
                }());


                return CryptoJS.SHA1;

            }));

            /***/
        },
/* 7 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var C_enc = C.enc;
                    var Utf8 = C_enc.Utf8;
                    var C_algo = C.algo;

                    /**
                     * HMAC algorithm.
                     */
                    var HMAC = C_algo.HMAC = Base.extend({
                        /**
                         * Initializes a newly created HMAC.
                         *
                         * @param {Hasher} hasher The hash algorithm to use.
                         * @param {WordArray|string} key The secret key.
                         *
                         * @example
                         *
                         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
                         */
                        init: function (hasher, key) {
                            // Init hasher
                            hasher = this._hasher = new hasher.init();

                            // Convert string to WordArray, else assume WordArray already
                            if (typeof key == 'string') {
                                key = Utf8.parse(key);
                            }

                            // Shortcuts
                            var hasherBlockSize = hasher.blockSize;
                            var hasherBlockSizeBytes = hasherBlockSize * 4;

                            // Allow arbitrary length keys
                            if (key.sigBytes > hasherBlockSizeBytes) {
                                key = hasher.finalize(key);
                            }

                            // Clamp excess bits
                            key.clamp();

                            // Clone key for inner and outer pads
                            var oKey = this._oKey = key.clone();
                            var iKey = this._iKey = key.clone();

                            // Shortcuts
                            var oKeyWords = oKey.words;
                            var iKeyWords = iKey.words;

                            // XOR keys with pad constants
                            for (var i = 0; i < hasherBlockSize; i++) {
                                oKeyWords[i] ^= 0x5c5c5c5c;
                                iKeyWords[i] ^= 0x36363636;
                            }
                            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

                            // Set initial values
                            this.reset();
                        },

                        /**
                         * Resets this HMAC to its initial state.
                         *
                         * @example
                         *
                         *     hmacHasher.reset();
                         */
                        reset: function () {
                            // Shortcut
                            var hasher = this._hasher;

                            // Reset
                            hasher.reset();
                            hasher.update(this._iKey);
                        },

                        /**
                         * Updates this HMAC with a message.
                         *
                         * @param {WordArray|string} messageUpdate The message to append.
                         *
                         * @return {HMAC} This HMAC instance.
                         *
                         * @example
                         *
                         *     hmacHasher.update('message');
                         *     hmacHasher.update(wordArray);
                         */
                        update: function (messageUpdate) {
                            this._hasher.update(messageUpdate);

                            // Chainable
                            return this;
                        },

                        /**
                         * Finalizes the HMAC computation.
                         * Note that the finalize operation is effectively a destructive, read-once operation.
                         *
                         * @param {WordArray|string} messageUpdate (Optional) A final message update.
                         *
                         * @return {WordArray} The HMAC.
                         *
                         * @example
                         *
                         *     var hmac = hmacHasher.finalize();
                         *     var hmac = hmacHasher.finalize('message');
                         *     var hmac = hmacHasher.finalize(wordArray);
                         */
                        finalize: function (messageUpdate) {
                            // Shortcut
                            var hasher = this._hasher;

                            // Compute HMAC
                            var innerHash = hasher.finalize(messageUpdate);
                            hasher.reset();
                            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

                            return hmac;
                        }
                    });
                }());


            }));

            /***/
        },
/* 8 */
/***/ function (module, exports) {

            'use strict';

            /*
             ES6 compatible port of CryptoJS - encoding
        	
             Source: https://github.com/brix/crypto-js
             LICENSE: MIT
             */
            var enc = {};

            enc.Latin1 = {
                stringify: function stringify(wordArray) {
                    // Shortcuts
                    var words = wordArray.words;
                    var sigBytes = wordArray.sigBytes;
                    var latin1Chars = [],
                        i = void 0,
                        bite = void 0;

                    // Convert
                    for (i = 0; i < sigBytes; i++) {
                        bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                        latin1Chars.push(String.fromCharCode(bite));
                    }

                    return latin1Chars.join('');
                }
            };

            enc._Utf8 = {
                stringify: function stringify(wordArray) {
                    try {
                        return decodeURIComponent(escape(enc.Latin1.stringify(wordArray)));
                    } catch (e) {
                        throw new Error('Malformed UTF-8 data');
                    }
                }
            };

            module.exports = enc;

            /***/
        },
/* 9 */
/***/ function (module, exports) {

            'use strict';

            var Base64 = {
                _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
                encode: function encode(e) {
                    var t = '';
                    var n = void 0,
                        r = void 0,
                        i = void 0,
                        s = void 0,
                        o = void 0,
                        u = void 0,
                        a = void 0;
                    var f = 0;

                    e = Base64._utf8Encode(e);
                    while (f < e.length) {
                        n = e.charCodeAt(f++);
                        r = e.charCodeAt(f++);
                        i = e.charCodeAt(f++);
                        s = n >> 2;
                        o = (n & 3) << 4 | r >> 4;
                        u = (r & 15) << 2 | i >> 6;
                        a = i & 63;
                        if (isNaN(r)) {
                            u = a = 64;
                        } else if (isNaN(i)) {
                            a = 64;
                        }
                        t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
                    }
                    return t;
                },
                decode: function decode(e) {
                    var t = '';
                    var n = void 0,
                        r = void 0,
                        i = void 0;
                    var s = void 0,
                        o = void 0,
                        u = void 0,
                        a = void 0;
                    var f = 0;

                    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, '');
                    while (f < e.length) {
                        s = this._keyStr.indexOf(e.charAt(f++));
                        o = this._keyStr.indexOf(e.charAt(f++));
                        u = this._keyStr.indexOf(e.charAt(f++));
                        a = this._keyStr.indexOf(e.charAt(f++));
                        n = s << 2 | o >> 4;
                        r = (o & 15) << 4 | u >> 2;
                        i = (u & 3) << 6 | a;
                        t = t + String.fromCharCode(n);
                        if (u !== 64) {
                            t = t + String.fromCharCode(r);
                        }
                        if (a !== 64) {
                            t = t + String.fromCharCode(i);
                        }
                    }
                    t = Base64._utf8Decode(t);
                    return t;
                },
                _utf8Encode: function _utf8Encode(e) {
                    e = e.replace(/\r\n/g, '\n');
                    var t = '';

                    for (var n = 0; n < e.length; n++) {
                        var r = e.charCodeAt(n);

                        if (r < 128) {
                            t += String.fromCharCode(r);
                        } else if (r > 127 && r < 2048) {
                            t += String.fromCharCode(r >> 6 | 192);
                            t += String.fromCharCode(r & 63 | 128);
                        } else {
                            t += String.fromCharCode(r >> 12 | 224);
                            t += String.fromCharCode(r >> 6 & 63 | 128);
                            t += String.fromCharCode(r & 63 | 128);
                        }
                    }
                    return t;
                },
                _utf8Decode: function _utf8Decode(e) {
                    var t = '';
                    var n = 0;
                    var r = void 0,
                        c2 = void 0,
                        c3 = void 0;

                    r = c2 = 0;
                    while (n < e.length) {
                        r = e.charCodeAt(n);
                        if (r < 128) {
                            t += String.fromCharCode(r);
                            n++;
                        } else if (r > 191 && r < 224) {
                            c2 = e.charCodeAt(n + 1);
                            t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                            n += 2;
                        } else {
                            c2 = e.charCodeAt(n + 1);
                            c3 = e.charCodeAt(n + 2);
                            t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                            n += 3;
                        }
                    }
                    return t;
                }
            };

            module.exports = Base64;

            /***/
        },
/* 10 */
/***/ function (module, exports, __webpack_require__) {

            var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
            // This work is free. You can redistribute it and/or modify it
            // under the terms of the WTFPL, Version 2
            // For more information see LICENSE.txt or http://www.wtfpl.net/
            //
            // For more information, the home page:
            // http://pieroxy.net/blog/pages/lz-string/testing.html
            //
            // LZ-based compression algorithm, version 1.4.4
            var LZString = (function () {

                // private property
                var f = String.fromCharCode;
                var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
                var baseReverseDic = {};

                function getBaseValue(alphabet, character) {
                    if (!baseReverseDic[alphabet]) {
                        baseReverseDic[alphabet] = {};
                        for (var i = 0; i < alphabet.length; i++) {
                            baseReverseDic[alphabet][alphabet.charAt(i)] = i;
                        }
                    }
                    return baseReverseDic[alphabet][character];
                }

                var LZString = {
                    compressToBase64: function (input) {
                        if (input == null) return "";
                        var res = LZString._compress(input, 6, function (a) { return keyStrBase64.charAt(a); });
                        switch (res.length % 4) { // To produce valid Base64
                            default: // When could this happen ?
                            case 0: return res;
                            case 1: return res + "===";
                            case 2: return res + "==";
                            case 3: return res + "=";
                        }
                    },

                    decompressFromBase64: function (input) {
                        if (input == null) return "";
                        if (input == "") return null;
                        return LZString._decompress(input.length, 32, function (index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
                    },

                    compressToUTF16: function (input) {
                        if (input == null) return "";
                        return LZString._compress(input, 15, function (a) { return f(a + 32); }) + " ";
                    },

                    decompressFromUTF16: function (compressed) {
                        if (compressed == null) return "";
                        if (compressed == "") return null;
                        return LZString._decompress(compressed.length, 16384, function (index) { return compressed.charCodeAt(index) - 32; });
                    },

                    //compress into uint8array (UCS-2 big endian format)
                    compressToUint8Array: function (uncompressed) {
                        var compressed = LZString.compress(uncompressed);
                        var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character

                        for (var i = 0, TotalLen = compressed.length; i < TotalLen; i++) {
                            var current_value = compressed.charCodeAt(i);
                            buf[i * 2] = current_value >>> 8;
                            buf[i * 2 + 1] = current_value % 256;
                        }
                        return buf;
                    },

                    //decompress from uint8array (UCS-2 big endian format)
                    decompressFromUint8Array: function (compressed) {
                        if (compressed === null || compressed === undefined) {
                            return LZString.decompress(compressed);
                        } else {
                            var buf = new Array(compressed.length / 2); // 2 bytes per character
                            for (var i = 0, TotalLen = buf.length; i < TotalLen; i++) {
                                buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                            }

                            var result = [];
                            buf.forEach(function (c) {
                                result.push(f(c));
                            });
                            return LZString.decompress(result.join(''));

                        }

                    },


                    //compress into a string that is already URI encoded
                    compressToEncodedURIComponent: function (input) {
                        if (input == null) return "";
                        return LZString._compress(input, 6, function (a) { return keyStrUriSafe.charAt(a); });
                    },

                    //decompress from an output of compressToEncodedURIComponent
                    decompressFromEncodedURIComponent: function (input) {
                        if (input == null) return "";
                        if (input == "") return null;
                        input = input.replace(/ /g, "+");
                        return LZString._decompress(input.length, 32, function (index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
                    },

                    compress: function (uncompressed) {
                        return LZString._compress(uncompressed, 16, function (a) { return f(a); });
                    },
                    _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
                        if (uncompressed == null) return "";
                        var i, value,
                            context_dictionary = {},
                            context_dictionaryToCreate = {},
                            context_c = "",
                            context_wc = "",
                            context_w = "",
                            context_enlargeIn = 2, // Compensate for the first entry which should not count
                            context_dictSize = 3,
                            context_numBits = 2,
                            context_data = [],
                            context_data_val = 0,
                            context_data_position = 0,
                            ii;

                        for (ii = 0; ii < uncompressed.length; ii += 1) {
                            context_c = uncompressed.charAt(ii);
                            if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                                context_dictionary[context_c] = context_dictSize++;
                                context_dictionaryToCreate[context_c] = true;
                            }

                            context_wc = context_w + context_c;
                            if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
                                context_w = context_wc;
                            } else {
                                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                                    if (context_w.charCodeAt(0) < 256) {
                                        for (i = 0; i < context_numBits; i++) {
                                            context_data_val = (context_data_val << 1);
                                            if (context_data_position == bitsPerChar - 1) {
                                                context_data_position = 0;
                                                context_data.push(getCharFromInt(context_data_val));
                                                context_data_val = 0;
                                            } else {
                                                context_data_position++;
                                            }
                                        }
                                        value = context_w.charCodeAt(0);
                                        for (i = 0; i < 8; i++) {
                                            context_data_val = (context_data_val << 1) | (value & 1);
                                            if (context_data_position == bitsPerChar - 1) {
                                                context_data_position = 0;
                                                context_data.push(getCharFromInt(context_data_val));
                                                context_data_val = 0;
                                            } else {
                                                context_data_position++;
                                            }
                                            value = value >> 1;
                                        }
                                    } else {
                                        value = 1;
                                        for (i = 0; i < context_numBits; i++) {
                                            context_data_val = (context_data_val << 1) | value;
                                            if (context_data_position == bitsPerChar - 1) {
                                                context_data_position = 0;
                                                context_data.push(getCharFromInt(context_data_val));
                                                context_data_val = 0;
                                            } else {
                                                context_data_position++;
                                            }
                                            value = 0;
                                        }
                                        value = context_w.charCodeAt(0);
                                        for (i = 0; i < 16; i++) {
                                            context_data_val = (context_data_val << 1) | (value & 1);
                                            if (context_data_position == bitsPerChar - 1) {
                                                context_data_position = 0;
                                                context_data.push(getCharFromInt(context_data_val));
                                                context_data_val = 0;
                                            } else {
                                                context_data_position++;
                                            }
                                            value = value >> 1;
                                        }
                                    }
                                    context_enlargeIn--;
                                    if (context_enlargeIn == 0) {
                                        context_enlargeIn = Math.pow(2, context_numBits);
                                        context_numBits++;
                                    }
                                    delete context_dictionaryToCreate[context_w];
                                } else {
                                    value = context_dictionary[context_w];
                                    for (i = 0; i < context_numBits; i++) {
                                        context_data_val = (context_data_val << 1) | (value & 1);
                                        if (context_data_position == bitsPerChar - 1) {
                                            context_data_position = 0;
                                            context_data.push(getCharFromInt(context_data_val));
                                            context_data_val = 0;
                                        } else {
                                            context_data_position++;
                                        }
                                        value = value >> 1;
                                    }


                                }
                                context_enlargeIn--;
                                if (context_enlargeIn == 0) {
                                    context_enlargeIn = Math.pow(2, context_numBits);
                                    context_numBits++;
                                }
                                // Add wc to the dictionary.
                                context_dictionary[context_wc] = context_dictSize++;
                                context_w = String(context_c);
                            }
                        }

                        // Output the code for w.
                        if (context_w !== "") {
                            if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                                if (context_w.charCodeAt(0) < 256) {
                                    for (i = 0; i < context_numBits; i++) {
                                        context_data_val = (context_data_val << 1);
                                        if (context_data_position == bitsPerChar - 1) {
                                            context_data_position = 0;
                                            context_data.push(getCharFromInt(context_data_val));
                                            context_data_val = 0;
                                        } else {
                                            context_data_position++;
                                        }
                                    }
                                    value = context_w.charCodeAt(0);
                                    for (i = 0; i < 8; i++) {
                                        context_data_val = (context_data_val << 1) | (value & 1);
                                        if (context_data_position == bitsPerChar - 1) {
                                            context_data_position = 0;
                                            context_data.push(getCharFromInt(context_data_val));
                                            context_data_val = 0;
                                        } else {
                                            context_data_position++;
                                        }
                                        value = value >> 1;
                                    }
                                } else {
                                    value = 1;
                                    for (i = 0; i < context_numBits; i++) {
                                        context_data_val = (context_data_val << 1) | value;
                                        if (context_data_position == bitsPerChar - 1) {
                                            context_data_position = 0;
                                            context_data.push(getCharFromInt(context_data_val));
                                            context_data_val = 0;
                                        } else {
                                            context_data_position++;
                                        }
                                        value = 0;
                                    }
                                    value = context_w.charCodeAt(0);
                                    for (i = 0; i < 16; i++) {
                                        context_data_val = (context_data_val << 1) | (value & 1);
                                        if (context_data_position == bitsPerChar - 1) {
                                            context_data_position = 0;
                                            context_data.push(getCharFromInt(context_data_val));
                                            context_data_val = 0;
                                        } else {
                                            context_data_position++;
                                        }
                                        value = value >> 1;
                                    }
                                }
                                context_enlargeIn--;
                                if (context_enlargeIn == 0) {
                                    context_enlargeIn = Math.pow(2, context_numBits);
                                    context_numBits++;
                                }
                                delete context_dictionaryToCreate[context_w];
                            } else {
                                value = context_dictionary[context_w];
                                for (i = 0; i < context_numBits; i++) {
                                    context_data_val = (context_data_val << 1) | (value & 1);
                                    if (context_data_position == bitsPerChar - 1) {
                                        context_data_position = 0;
                                        context_data.push(getCharFromInt(context_data_val));
                                        context_data_val = 0;
                                    } else {
                                        context_data_position++;
                                    }
                                    value = value >> 1;
                                }


                            }
                            context_enlargeIn--;
                            if (context_enlargeIn == 0) {
                                context_enlargeIn = Math.pow(2, context_numBits);
                                context_numBits++;
                            }
                        }

                        // Mark the end of the stream
                        value = 2;
                        for (i = 0; i < context_numBits; i++) {
                            context_data_val = (context_data_val << 1) | (value & 1);
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else {
                                context_data_position++;
                            }
                            value = value >> 1;
                        }

                        // Flush the last char
                        while (true) {
                            context_data_val = (context_data_val << 1);
                            if (context_data_position == bitsPerChar - 1) {
                                context_data.push(getCharFromInt(context_data_val));
                                break;
                            }
                            else context_data_position++;
                        }
                        return context_data.join('');
                    },

                    decompress: function (compressed) {
                        if (compressed == null) return "";
                        if (compressed == "") return null;
                        return LZString._decompress(compressed.length, 32768, function (index) { return compressed.charCodeAt(index); });
                    },

                    _decompress: function (length, resetValue, getNextValue) {
                        var dictionary = [],
                            next,
                            enlargeIn = 4,
                            dictSize = 4,
                            numBits = 3,
                            entry = "",
                            result = [],
                            i,
                            w,
                            bits, resb, maxpower, power,
                            c,
                            data = { val: getNextValue(0), position: resetValue, index: 1 };

                        for (i = 0; i < 3; i += 1) {
                            dictionary[i] = i;
                        }

                        bits = 0;
                        maxpower = Math.pow(2, 2);
                        power = 1;
                        while (power != maxpower) {
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }

                        switch (next = bits) {
                            case 0:
                                bits = 0;
                                maxpower = Math.pow(2, 8);
                                power = 1;
                                while (power != maxpower) {
                                    resb = data.val & data.position;
                                    data.position >>= 1;
                                    if (data.position == 0) {
                                        data.position = resetValue;
                                        data.val = getNextValue(data.index++);
                                    }
                                    bits |= (resb > 0 ? 1 : 0) * power;
                                    power <<= 1;
                                }
                                c = f(bits);
                                break;
                            case 1:
                                bits = 0;
                                maxpower = Math.pow(2, 16);
                                power = 1;
                                while (power != maxpower) {
                                    resb = data.val & data.position;
                                    data.position >>= 1;
                                    if (data.position == 0) {
                                        data.position = resetValue;
                                        data.val = getNextValue(data.index++);
                                    }
                                    bits |= (resb > 0 ? 1 : 0) * power;
                                    power <<= 1;
                                }
                                c = f(bits);
                                break;
                            case 2:
                                return "";
                        }
                        dictionary[3] = c;
                        w = c;
                        result.push(c);
                        while (true) {
                            if (data.index > length) {
                                return "";
                            }

                            bits = 0;
                            maxpower = Math.pow(2, numBits);
                            power = 1;
                            while (power != maxpower) {
                                resb = data.val & data.position;
                                data.position >>= 1;
                                if (data.position == 0) {
                                    data.position = resetValue;
                                    data.val = getNextValue(data.index++);
                                }
                                bits |= (resb > 0 ? 1 : 0) * power;
                                power <<= 1;
                            }

                            switch (c = bits) {
                                case 0:
                                    bits = 0;
                                    maxpower = Math.pow(2, 8);
                                    power = 1;
                                    while (power != maxpower) {
                                        resb = data.val & data.position;
                                        data.position >>= 1;
                                        if (data.position == 0) {
                                            data.position = resetValue;
                                            data.val = getNextValue(data.index++);
                                        }
                                        bits |= (resb > 0 ? 1 : 0) * power;
                                        power <<= 1;
                                    }

                                    dictionary[dictSize++] = f(bits);
                                    c = dictSize - 1;
                                    enlargeIn--;
                                    break;
                                case 1:
                                    bits = 0;
                                    maxpower = Math.pow(2, 16);
                                    power = 1;
                                    while (power != maxpower) {
                                        resb = data.val & data.position;
                                        data.position >>= 1;
                                        if (data.position == 0) {
                                            data.position = resetValue;
                                            data.val = getNextValue(data.index++);
                                        }
                                        bits |= (resb > 0 ? 1 : 0) * power;
                                        power <<= 1;
                                    }
                                    dictionary[dictSize++] = f(bits);
                                    c = dictSize - 1;
                                    enlargeIn--;
                                    break;
                                case 2:
                                    return result.join('');
                            }

                            if (enlargeIn == 0) {
                                enlargeIn = Math.pow(2, numBits);
                                numBits++;
                            }

                            if (dictionary[c]) {
                                entry = dictionary[c];
                            } else {
                                if (c === dictSize) {
                                    entry = w + w.charAt(0);
                                } else {
                                    return null;
                                }
                            }
                            result.push(entry);

                            // Add w+entry[0] to the dictionary.
                            dictionary[dictSize++] = w + entry.charAt(0);
                            enlargeIn--;

                            w = entry;

                            if (enlargeIn == 0) {
                                enlargeIn = Math.pow(2, numBits);
                                numBits++;
                            }

                        }
                    }
                };
                return LZString;
            })();

            if (true) {
                !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return LZString; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else if (typeof module !== 'undefined' && module != null) {
                module.exports = LZString
            }


            /***/
        },
/* 11 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(15));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var BlockCipher = C_lib.BlockCipher;
                    var C_algo = C.algo;

                    // Lookup tables
                    var SBOX = [];
                    var INV_SBOX = [];
                    var SUB_MIX_0 = [];
                    var SUB_MIX_1 = [];
                    var SUB_MIX_2 = [];
                    var SUB_MIX_3 = [];
                    var INV_SUB_MIX_0 = [];
                    var INV_SUB_MIX_1 = [];
                    var INV_SUB_MIX_2 = [];
                    var INV_SUB_MIX_3 = [];

                    // Compute lookup tables
                    (function () {
                        // Compute double table
                        var d = [];
                        for (var i = 0; i < 256; i++) {
                            if (i < 128) {
                                d[i] = i << 1;
                            } else {
                                d[i] = (i << 1) ^ 0x11b;
                            }
                        }

                        // Walk GF(2^8)
                        var x = 0;
                        var xi = 0;
                        for (var i = 0; i < 256; i++) {
                            // Compute sbox
                            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
                            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
                            SBOX[x] = sx;
                            INV_SBOX[sx] = x;

                            // Compute multiplication
                            var x2 = d[x];
                            var x4 = d[x2];
                            var x8 = d[x4];

                            // Compute sub bytes, mix columns tables
                            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
                            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
                            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
                            SUB_MIX_2[x] = (t << 8) | (t >>> 24);
                            SUB_MIX_3[x] = t;

                            // Compute inv sub bytes, inv mix columns tables
                            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
                            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
                            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
                            INV_SUB_MIX_2[sx] = (t << 8) | (t >>> 24);
                            INV_SUB_MIX_3[sx] = t;

                            // Compute next counter
                            if (!x) {
                                x = xi = 1;
                            } else {
                                x = x2 ^ d[d[d[x8 ^ x2]]];
                                xi ^= d[d[xi]];
                            }
                        }
                    }());

                    // Precomputed Rcon lookup
                    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

                    /**
                     * AES block cipher algorithm.
                     */
                    var AES = C_algo.AES = BlockCipher.extend({
                        _doReset: function () {
                            // Skip reset of nRounds has been set before and key did not change
                            if (this._nRounds && this._keyPriorReset === this._key) {
                                return;
                            }

                            // Shortcuts
                            var key = this._keyPriorReset = this._key;
                            var keyWords = key.words;
                            var keySize = key.sigBytes / 4;

                            // Compute number of rounds
                            var nRounds = this._nRounds = keySize + 6;

                            // Compute number of key schedule rows
                            var ksRows = (nRounds + 1) * 4;

                            // Compute key schedule
                            var keySchedule = this._keySchedule = [];
                            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
                                if (ksRow < keySize) {
                                    keySchedule[ksRow] = keyWords[ksRow];
                                } else {
                                    var t = keySchedule[ksRow - 1];

                                    if (!(ksRow % keySize)) {
                                        // Rot word
                                        t = (t << 8) | (t >>> 24);

                                        // Sub word
                                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

                                        // Mix Rcon
                                        t ^= RCON[(ksRow / keySize) | 0] << 24;
                                    } else if (keySize > 6 && ksRow % keySize == 4) {
                                        // Sub word
                                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
                                    }

                                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                                }
                            }

                            // Compute inv key schedule
                            var invKeySchedule = this._invKeySchedule = [];
                            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
                                var ksRow = ksRows - invKsRow;

                                if (invKsRow % 4) {
                                    var t = keySchedule[ksRow];
                                } else {
                                    var t = keySchedule[ksRow - 4];
                                }

                                if (invKsRow < 4 || ksRow <= 4) {
                                    invKeySchedule[invKsRow] = t;
                                } else {
                                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
                                        INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                                }
                            }
                        },

                        encryptBlock: function (M, offset) {
                            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
                        },

                        decryptBlock: function (M, offset) {
                            // Swap 2nd and 4th rows
                            var t = M[offset + 1];
                            M[offset + 1] = M[offset + 3];
                            M[offset + 3] = t;

                            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

                            // Inv swap 2nd and 4th rows
                            var t = M[offset + 1];
                            M[offset + 1] = M[offset + 3];
                            M[offset + 3] = t;
                        },

                        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                            // Shortcut
                            var nRounds = this._nRounds;

                            // Get input, add round key
                            var s0 = M[offset] ^ keySchedule[0];
                            var s1 = M[offset + 1] ^ keySchedule[1];
                            var s2 = M[offset + 2] ^ keySchedule[2];
                            var s3 = M[offset + 3] ^ keySchedule[3];

                            // Key schedule row counter
                            var ksRow = 4;

                            // Rounds
                            for (var round = 1; round < nRounds; round++) {
                                // Shift rows, sub bytes, mix columns, add round key
                                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

                                // Update state
                                s0 = t0;
                                s1 = t1;
                                s2 = t2;
                                s3 = t3;
                            }

                            // Shift rows, sub bytes, add round key
                            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

                            // Set output
                            M[offset] = t0;
                            M[offset + 1] = t1;
                            M[offset + 2] = t2;
                            M[offset + 3] = t3;
                        },

                        keySize: 256 / 32
                    });

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
                     */
                    C.AES = BlockCipher._createHelper(AES);
                }());


                return CryptoJS.AES;

            }));

            /***/
        },
/* 12 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var C_enc = C.enc;

                    /**
                     * Base64 encoding strategy.
                     */
                    var Base64 = C_enc.Base64 = {
                        /**
                         * Converts a word array to a Base64 string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The Base64 string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                            // Shortcuts
                            var words = wordArray.words;
                            var sigBytes = wordArray.sigBytes;
                            var map = this._map;

                            // Clamp excess bits
                            wordArray.clamp();

                            // Convert
                            var base64Chars = [];
                            for (var i = 0; i < sigBytes; i += 3) {
                                var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
                                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

                                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

                                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
                                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
                                }
                            }

                            // Add padding
                            var paddingChar = map.charAt(64);
                            if (paddingChar) {
                                while (base64Chars.length % 4) {
                                    base64Chars.push(paddingChar);
                                }
                            }

                            return base64Chars.join('');
                        },

                        /**
                         * Converts a Base64 string to a word array.
                         *
                         * @param {string} base64Str The Base64 string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
                         */
                        parse: function (base64Str) {
                            // Shortcuts
                            var base64StrLength = base64Str.length;
                            var map = this._map;
                            var reverseMap = this._reverseMap;

                            if (!reverseMap) {
                                reverseMap = this._reverseMap = [];
                                for (var j = 0; j < map.length; j++) {
                                    reverseMap[map.charCodeAt(j)] = j;
                                }
                            }

                            // Ignore padding
                            var paddingChar = map.charAt(64);
                            if (paddingChar) {
                                var paddingIndex = base64Str.indexOf(paddingChar);
                                if (paddingIndex !== -1) {
                                    base64StrLength = paddingIndex;
                                }
                            }

                            // Convert
                            return parseLoop(base64Str, base64StrLength, reverseMap);

                        },

                        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
                    };

                    function parseLoop(base64Str, base64StrLength, reverseMap) {
                        var words = [];
                        var nBytes = 0;
                        for (var i = 0; i < base64StrLength; i++) {
                            if (i % 4) {
                                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
                                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
                                words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
                                nBytes++;
                            }
                        }
                        return WordArray.create(words, nBytes);
                    }
                }());


                return CryptoJS.enc.Base64;

            }));

            /***/
        },
/* 13 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function (Math) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var Hasher = C_lib.Hasher;
                    var C_algo = C.algo;

                    // Constants table
                    var T = [];

                    // Compute constants
                    (function () {
                        for (var i = 0; i < 64; i++) {
                            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
                        }
                    }());

                    /**
                     * MD5 hash algorithm.
                     */
                    var MD5 = C_algo.MD5 = Hasher.extend({
                        _doReset: function () {
                            this._hash = new WordArray.init([
                                0x67452301, 0xefcdab89,
                                0x98badcfe, 0x10325476
                            ]);
                        },

                        _doProcessBlock: function (M, offset) {
                            // Swap endian
                            for (var i = 0; i < 16; i++) {
                                // Shortcuts
                                var offset_i = offset + i;
                                var M_offset_i = M[offset_i];

                                M[offset_i] = (
                                    (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
                                    (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00)
                                );
                            }

                            // Shortcuts
                            var H = this._hash.words;

                            var M_offset_0 = M[offset + 0];
                            var M_offset_1 = M[offset + 1];
                            var M_offset_2 = M[offset + 2];
                            var M_offset_3 = M[offset + 3];
                            var M_offset_4 = M[offset + 4];
                            var M_offset_5 = M[offset + 5];
                            var M_offset_6 = M[offset + 6];
                            var M_offset_7 = M[offset + 7];
                            var M_offset_8 = M[offset + 8];
                            var M_offset_9 = M[offset + 9];
                            var M_offset_10 = M[offset + 10];
                            var M_offset_11 = M[offset + 11];
                            var M_offset_12 = M[offset + 12];
                            var M_offset_13 = M[offset + 13];
                            var M_offset_14 = M[offset + 14];
                            var M_offset_15 = M[offset + 15];

                            // Working varialbes
                            var a = H[0];
                            var b = H[1];
                            var c = H[2];
                            var d = H[3];

                            // Computation
                            a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                            d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                            c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                            b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                            a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                            d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                            c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                            b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                            a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                            d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                            a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

                            a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                            d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                            b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                            a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                            d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                            b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                            a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                            d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                            c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                            b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                            a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                            d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                            c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

                            a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                            d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                            a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                            d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                            c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                            a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                            d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                            c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                            b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                            a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                            b = HH(b, c, d, a, M_offset_2, 23, T[47]);

                            a = II(a, b, c, d, M_offset_0, 6, T[48]);
                            d = II(d, a, b, c, M_offset_7, 10, T[49]);
                            c = II(c, d, a, b, M_offset_14, 15, T[50]);
                            b = II(b, c, d, a, M_offset_5, 21, T[51]);
                            a = II(a, b, c, d, M_offset_12, 6, T[52]);
                            d = II(d, a, b, c, M_offset_3, 10, T[53]);
                            c = II(c, d, a, b, M_offset_10, 15, T[54]);
                            b = II(b, c, d, a, M_offset_1, 21, T[55]);
                            a = II(a, b, c, d, M_offset_8, 6, T[56]);
                            d = II(d, a, b, c, M_offset_15, 10, T[57]);
                            c = II(c, d, a, b, M_offset_6, 15, T[58]);
                            b = II(b, c, d, a, M_offset_13, 21, T[59]);
                            a = II(a, b, c, d, M_offset_4, 6, T[60]);
                            d = II(d, a, b, c, M_offset_11, 10, T[61]);
                            c = II(c, d, a, b, M_offset_2, 15, T[62]);
                            b = II(b, c, d, a, M_offset_9, 21, T[63]);

                            // Intermediate hash value
                            H[0] = (H[0] + a) | 0;
                            H[1] = (H[1] + b) | 0;
                            H[2] = (H[2] + c) | 0;
                            H[3] = (H[3] + d) | 0;
                        },

                        _doFinalize: function () {
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;

                            var nBitsTotal = this._nDataBytes * 8;
                            var nBitsLeft = data.sigBytes * 8;

                            // Add padding
                            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

                            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
                            var nBitsTotalL = nBitsTotal;
                            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
                                (((nBitsTotalH << 8) | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
                                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8)) & 0xff00ff00)
                            );
                            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
                                (((nBitsTotalL << 8) | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
                                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8)) & 0xff00ff00)
                            );

                            data.sigBytes = (dataWords.length + 1) * 4;

                            // Hash final blocks
                            this._process();

                            // Shortcuts
                            var hash = this._hash;
                            var H = hash.words;

                            // Swap endian
                            for (var i = 0; i < 4; i++) {
                                // Shortcut
                                var H_i = H[i];

                                H[i] = (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
                                    (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00);
                            }

                            // Return final computed hash
                            return hash;
                        },

                        clone: function () {
                            var clone = Hasher.clone.call(this);
                            clone._hash = this._hash.clone();

                            return clone;
                        }
                    });

                    function FF(a, b, c, d, x, s, t) {
                        var n = a + ((b & c) | (~b & d)) + x + t;
                        return ((n << s) | (n >>> (32 - s))) + b;
                    }

                    function GG(a, b, c, d, x, s, t) {
                        var n = a + ((b & d) | (c & ~d)) + x + t;
                        return ((n << s) | (n >>> (32 - s))) + b;
                    }

                    function HH(a, b, c, d, x, s, t) {
                        var n = a + (b ^ c ^ d) + x + t;
                        return ((n << s) | (n >>> (32 - s))) + b;
                    }

                    function II(a, b, c, d, x, s, t) {
                        var n = a + (c ^ (b | ~d)) + x + t;
                        return ((n << s) | (n >>> (32 - s))) + b;
                    }

                    /**
                     * Shortcut function to the hasher's object interface.
                     *
                     * @param {WordArray|string} message The message to hash.
                     *
                     * @return {WordArray} The hash.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hash = CryptoJS.MD5('message');
                     *     var hash = CryptoJS.MD5(wordArray);
                     */
                    C.MD5 = Hasher._createHelper(MD5);

                    /**
                     * Shortcut function to the HMAC's object interface.
                     *
                     * @param {WordArray|string} message The message to hash.
                     * @param {WordArray|string} key The secret key.
                     *
                     * @return {WordArray} The HMAC.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hmac = CryptoJS.HmacMD5(message, key);
                     */
                    C.HmacMD5 = Hasher._createHmacHelper(MD5);
                }(Math));


                return CryptoJS.MD5;

            }));

            /***/
        },
/* 14 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(6), __webpack_require__(7));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./sha1", "./hmac"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var C_algo = C.algo;
                    var MD5 = C_algo.MD5;

                    /**
                     * This key derivation function is meant to conform with EVP_BytesToKey.
                     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
                     */
                    var EvpKDF = C_algo.EvpKDF = Base.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
                         * @property {number} iterations The number of iterations to perform. Default: 1
                         */
                        cfg: Base.extend({
                            keySize: 128 / 32,
                            hasher: MD5,
                            iterations: 1
                        }),

                        /**
                         * Initializes a newly created key derivation function.
                         *
                         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                         *
                         * @example
                         *
                         *     var kdf = CryptoJS.algo.EvpKDF.create();
                         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
                         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
                         */
                        init: function (cfg) {
                            this.cfg = this.cfg.extend(cfg);
                        },

                        /**
                         * Derives a key from a password.
                         *
                         * @param {WordArray|string} password The password.
                         * @param {WordArray|string} salt A salt.
                         *
                         * @return {WordArray} The derived key.
                         *
                         * @example
                         *
                         *     var key = kdf.compute(password, salt);
                         */
                        compute: function (password, salt) {
                            // Shortcut
                            var cfg = this.cfg;

                            // Init hasher
                            var hasher = cfg.hasher.create();

                            // Initial values
                            var derivedKey = WordArray.create();

                            // Shortcuts
                            var derivedKeyWords = derivedKey.words;
                            var keySize = cfg.keySize;
                            var iterations = cfg.iterations;

                            // Generate key
                            while (derivedKeyWords.length < keySize) {
                                if (block) {
                                    hasher.update(block);
                                }
                                var block = hasher.update(password).finalize(salt);
                                hasher.reset();

                                // Iterations
                                for (var i = 1; i < iterations; i++) {
                                    block = hasher.finalize(block);
                                    hasher.reset();
                                }

                                derivedKey.concat(block);
                            }
                            derivedKey.sigBytes = keySize * 4;

                            return derivedKey;
                        }
                    });

                    /**
                     * Derives a key from a password.
                     *
                     * @param {WordArray|string} password The password.
                     * @param {WordArray|string} salt A salt.
                     * @param {Object} cfg (Optional) The configuration options to use for this computation.
                     *
                     * @return {WordArray} The derived key.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var key = CryptoJS.EvpKDF(password, salt);
                     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
                     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
                     */
                    C.EvpKDF = function (password, salt, cfg) {
                        return EvpKDF.create(cfg).compute(password, salt);
                    };
                }());


                return CryptoJS.EvpKDF;

            }));

            /***/
        },
/* 15 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                /**
                 * Cipher core components.
                 */
                CryptoJS.lib.Cipher || (function (undefined) {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var Base = C_lib.Base;
                    var WordArray = C_lib.WordArray;
                    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
                    var C_enc = C.enc;
                    var Utf8 = C_enc.Utf8;
                    var Base64 = C_enc.Base64;
                    var C_algo = C.algo;
                    var EvpKDF = C_algo.EvpKDF;

                    /**
                     * Abstract base cipher template.
                     *
                     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
                     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
                     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
                     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
                     */
                    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {WordArray} iv The IV to use for this operation.
                         */
                        cfg: Base.extend(),

                        /**
                         * Creates this cipher in encryption mode.
                         *
                         * @param {WordArray} key The key.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {Cipher} A cipher instance.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
                         */
                        createEncryptor: function (key, cfg) {
                            return this.create(this._ENC_XFORM_MODE, key, cfg);
                        },

                        /**
                         * Creates this cipher in decryption mode.
                         *
                         * @param {WordArray} key The key.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {Cipher} A cipher instance.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
                         */
                        createDecryptor: function (key, cfg) {
                            return this.create(this._DEC_XFORM_MODE, key, cfg);
                        },

                        /**
                         * Initializes a newly created cipher.
                         *
                         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
                         * @param {WordArray} key The key.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @example
                         *
                         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
                         */
                        init: function (xformMode, key, cfg) {
                            // Apply config defaults
                            this.cfg = this.cfg.extend(cfg);

                            // Store transform mode and key
                            this._xformMode = xformMode;
                            this._key = key;

                            // Set initial values
                            this.reset();
                        },

                        /**
                         * Resets this cipher to its initial state.
                         *
                         * @example
                         *
                         *     cipher.reset();
                         */
                        reset: function () {
                            // Reset data buffer
                            BufferedBlockAlgorithm.reset.call(this);

                            // Perform concrete-cipher logic
                            this._doReset();
                        },

                        /**
                         * Adds data to be encrypted or decrypted.
                         *
                         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
                         *
                         * @return {WordArray} The data after processing.
                         *
                         * @example
                         *
                         *     var encrypted = cipher.process('data');
                         *     var encrypted = cipher.process(wordArray);
                         */
                        process: function (dataUpdate) {
                            // Append
                            this._append(dataUpdate);

                            // Process available blocks
                            return this._process();
                        },

                        /**
                         * Finalizes the encryption or decryption process.
                         * Note that the finalize operation is effectively a destructive, read-once operation.
                         *
                         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
                         *
                         * @return {WordArray} The data after final processing.
                         *
                         * @example
                         *
                         *     var encrypted = cipher.finalize();
                         *     var encrypted = cipher.finalize('data');
                         *     var encrypted = cipher.finalize(wordArray);
                         */
                        finalize: function (dataUpdate) {
                            // Final data update
                            if (dataUpdate) {
                                this._append(dataUpdate);
                            }

                            // Perform concrete-cipher logic
                            var finalProcessedData = this._doFinalize();

                            return finalProcessedData;
                        },

                        keySize: 128 / 32,

                        ivSize: 128 / 32,

                        _ENC_XFORM_MODE: 1,

                        _DEC_XFORM_MODE: 2,

                        /**
                         * Creates shortcut functions to a cipher's object interface.
                         *
                         * @param {Cipher} cipher The cipher to create a helper for.
                         *
                         * @return {Object} An object with encrypt and decrypt shortcut functions.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
                         */
                        _createHelper: (function () {
                            function selectCipherStrategy(key) {
                                if (typeof key == 'string') {
                                    return PasswordBasedCipher;
                                } else {
                                    return SerializableCipher;
                                }
                            }

                            return function (cipher) {
                                return {
                                    encrypt: function (message, key, cfg) {
                                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                                    },

                                    decrypt: function (ciphertext, key, cfg) {
                                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                                    }
                                };
                            };
                        }())
                    });

                    /**
                     * Abstract base stream cipher template.
                     *
                     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
                     */
                    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
                        _doFinalize: function () {
                            // Process partial blocks
                            var finalProcessedBlocks = this._process(!!'flush');

                            return finalProcessedBlocks;
                        },

                        blockSize: 1
                    });

                    /**
                     * Mode namespace.
                     */
                    var C_mode = C.mode = {};

                    /**
                     * Abstract base block cipher mode template.
                     */
                    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
                        /**
                         * Creates this mode for encryption.
                         *
                         * @param {Cipher} cipher A block cipher instance.
                         * @param {Array} iv The IV words.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
                         */
                        createEncryptor: function (cipher, iv) {
                            return this.Encryptor.create(cipher, iv);
                        },

                        /**
                         * Creates this mode for decryption.
                         *
                         * @param {Cipher} cipher A block cipher instance.
                         * @param {Array} iv The IV words.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
                         */
                        createDecryptor: function (cipher, iv) {
                            return this.Decryptor.create(cipher, iv);
                        },

                        /**
                         * Initializes a newly created mode.
                         *
                         * @param {Cipher} cipher A block cipher instance.
                         * @param {Array} iv The IV words.
                         *
                         * @example
                         *
                         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
                         */
                        init: function (cipher, iv) {
                            this._cipher = cipher;
                            this._iv = iv;
                        }
                    });

                    /**
                     * Cipher Block Chaining mode.
                     */
                    var CBC = C_mode.CBC = (function () {
                        /**
                         * Abstract base CBC mode.
                         */
                        var CBC = BlockCipherMode.extend();

                        /**
                         * CBC encryptor.
                         */
                        CBC.Encryptor = CBC.extend({
                            /**
                             * Processes the data block at offset.
                             *
                             * @param {Array} words The data words to operate on.
                             * @param {number} offset The offset where the block starts.
                             *
                             * @example
                             *
                             *     mode.processBlock(data.words, offset);
                             */
                            processBlock: function (words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;

                                // XOR and encrypt
                                xorBlock.call(this, words, offset, blockSize);
                                cipher.encryptBlock(words, offset);

                                // Remember this block to use with next block
                                this._prevBlock = words.slice(offset, offset + blockSize);
                            }
                        });

                        /**
                         * CBC decryptor.
                         */
                        CBC.Decryptor = CBC.extend({
                            /**
                             * Processes the data block at offset.
                             *
                             * @param {Array} words The data words to operate on.
                             * @param {number} offset The offset where the block starts.
                             *
                             * @example
                             *
                             *     mode.processBlock(data.words, offset);
                             */
                            processBlock: function (words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;

                                // Remember this block to use with next block
                                var thisBlock = words.slice(offset, offset + blockSize);

                                // Decrypt and XOR
                                cipher.decryptBlock(words, offset);
                                xorBlock.call(this, words, offset, blockSize);

                                // This block becomes the previous block
                                this._prevBlock = thisBlock;
                            }
                        });

                        function xorBlock(words, offset, blockSize) {
                            // Shortcut
                            var iv = this._iv;

                            // Choose mixing block
                            if (iv) {
                                var block = iv;

                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            } else {
                                var block = this._prevBlock;
                            }

                            // XOR blocks
                            for (var i = 0; i < blockSize; i++) {
                                words[offset + i] ^= block[i];
                            }
                        }

                        return CBC;
                    }());

                    /**
                     * Padding namespace.
                     */
                    var C_pad = C.pad = {};

                    /**
                     * PKCS #5/7 padding strategy.
                     */
                    var Pkcs7 = C_pad.Pkcs7 = {
                        /**
                         * Pads data using the algorithm defined in PKCS #5/7.
                         *
                         * @param {WordArray} data The data to pad.
                         * @param {number} blockSize The multiple that the data should be padded to.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
                         */
                        pad: function (data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;

                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

                            // Create padding word
                            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

                            // Create padding
                            var paddingWords = [];
                            for (var i = 0; i < nPaddingBytes; i += 4) {
                                paddingWords.push(paddingWord);
                            }
                            var padding = WordArray.create(paddingWords, nPaddingBytes);

                            // Add padding
                            data.concat(padding);
                        },

                        /**
                         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
                         *
                         * @param {WordArray} data The data to unpad.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
                         */
                        unpad: function (data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };

                    /**
                     * Abstract base block cipher template.
                     *
                     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
                     */
                    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {Mode} mode The block mode to use. Default: CBC
                         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
                         */
                        cfg: Cipher.cfg.extend({
                            mode: CBC,
                            padding: Pkcs7
                        }),

                        reset: function () {
                            // Reset cipher
                            Cipher.reset.call(this);

                            // Shortcuts
                            var cfg = this.cfg;
                            var iv = cfg.iv;
                            var mode = cfg.mode;

                            // Reset block mode
                            if (this._xformMode == this._ENC_XFORM_MODE) {
                                var modeCreator = mode.createEncryptor;
                            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                var modeCreator = mode.createDecryptor;

                                // Keep at least one block in the buffer for unpadding
                                this._minBufferSize = 1;
                            }
                            this._mode = modeCreator.call(mode, this, iv && iv.words);
                        },

                        _doProcessBlock: function (words, offset) {
                            this._mode.processBlock(words, offset);
                        },

                        _doFinalize: function () {
                            // Shortcut
                            var padding = this.cfg.padding;

                            // Finalize
                            if (this._xformMode == this._ENC_XFORM_MODE) {
                                // Pad data
                                padding.pad(this._data, this.blockSize);

                                // Process final blocks
                                var finalProcessedBlocks = this._process(!!'flush');
                            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                // Process final blocks
                                var finalProcessedBlocks = this._process(!!'flush');

                                // Unpad data
                                padding.unpad(finalProcessedBlocks);
                            }

                            return finalProcessedBlocks;
                        },

                        blockSize: 128 / 32
                    });

                    /**
                     * A collection of cipher parameters.
                     *
                     * @property {WordArray} ciphertext The raw ciphertext.
                     * @property {WordArray} key The key to this ciphertext.
                     * @property {WordArray} iv The IV used in the ciphering operation.
                     * @property {WordArray} salt The salt used with a key derivation function.
                     * @property {Cipher} algorithm The cipher algorithm.
                     * @property {Mode} mode The block mode used in the ciphering operation.
                     * @property {Padding} padding The padding scheme used in the ciphering operation.
                     * @property {number} blockSize The block size of the cipher.
                     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
                     */
                    var CipherParams = C_lib.CipherParams = Base.extend({
                        /**
                         * Initializes a newly created cipher params object.
                         *
                         * @param {Object} cipherParams An object with any of the possible cipher parameters.
                         *
                         * @example
                         *
                         *     var cipherParams = CryptoJS.lib.CipherParams.create({
                         *         ciphertext: ciphertextWordArray,
                         *         key: keyWordArray,
                         *         iv: ivWordArray,
                         *         salt: saltWordArray,
                         *         algorithm: CryptoJS.algo.AES,
                         *         mode: CryptoJS.mode.CBC,
                         *         padding: CryptoJS.pad.PKCS7,
                         *         blockSize: 4,
                         *         formatter: CryptoJS.format.OpenSSL
                         *     });
                         */
                        init: function (cipherParams) {
                            this.mixIn(cipherParams);
                        },

                        /**
                         * Converts this cipher params object to a string.
                         *
                         * @param {Format} formatter (Optional) The formatting strategy to use.
                         *
                         * @return {string} The stringified cipher params.
                         *
                         * @throws Error If neither the formatter nor the default formatter is set.
                         *
                         * @example
                         *
                         *     var string = cipherParams + '';
                         *     var string = cipherParams.toString();
                         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
                         */
                        toString: function (formatter) {
                            return (formatter || this.formatter).stringify(this);
                        }
                    });

                    /**
                     * Format namespace.
                     */
                    var C_format = C.format = {};

                    /**
                     * OpenSSL formatting strategy.
                     */
                    var OpenSSLFormatter = C_format.OpenSSL = {
                        /**
                         * Converts a cipher params object to an OpenSSL-compatible string.
                         *
                         * @param {CipherParams} cipherParams The cipher params object.
                         *
                         * @return {string} The OpenSSL-compatible string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
                         */
                        stringify: function (cipherParams) {
                            // Shortcuts
                            var ciphertext = cipherParams.ciphertext;
                            var salt = cipherParams.salt;

                            // Format
                            if (salt) {
                                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
                            } else {
                                var wordArray = ciphertext;
                            }

                            return wordArray.toString(Base64);
                        },

                        /**
                         * Converts an OpenSSL-compatible string to a cipher params object.
                         *
                         * @param {string} openSSLStr The OpenSSL-compatible string.
                         *
                         * @return {CipherParams} The cipher params object.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
                         */
                        parse: function (openSSLStr) {
                            // Parse base64
                            var ciphertext = Base64.parse(openSSLStr);

                            // Shortcut
                            var ciphertextWords = ciphertext.words;

                            // Test for salt
                            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                                // Extract salt
                                var salt = WordArray.create(ciphertextWords.slice(2, 4));

                                // Remove salt from ciphertext
                                ciphertextWords.splice(0, 4);
                                ciphertext.sigBytes -= 16;
                            }

                            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
                        }
                    };

                    /**
                     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
                     */
                    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
                         */
                        cfg: Base.extend({
                            format: OpenSSLFormatter
                        }),

                        /**
                         * Encrypts a message.
                         *
                         * @param {Cipher} cipher The cipher algorithm to use.
                         * @param {WordArray|string} message The message to encrypt.
                         * @param {WordArray} key The key.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {CipherParams} A cipher params object.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
                         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
                         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                         */
                        encrypt: function (cipher, message, key, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);

                            // Encrypt
                            var encryptor = cipher.createEncryptor(key, cfg);
                            var ciphertext = encryptor.finalize(message);

                            // Shortcut
                            var cipherCfg = encryptor.cfg;

                            // Create and return serializable cipher params
                            return CipherParams.create({
                                ciphertext: ciphertext,
                                key: key,
                                iv: cipherCfg.iv,
                                algorithm: cipher,
                                mode: cipherCfg.mode,
                                padding: cipherCfg.padding,
                                blockSize: cipher.blockSize,
                                formatter: cfg.format
                            });
                        },

                        /**
                         * Decrypts serialized ciphertext.
                         *
                         * @param {Cipher} cipher The cipher algorithm to use.
                         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                         * @param {WordArray} key The key.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {WordArray} The plaintext.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                         */
                        decrypt: function (cipher, ciphertext, key, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);

                            // Convert string to CipherParams
                            ciphertext = this._parse(ciphertext, cfg.format);

                            // Decrypt
                            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

                            return plaintext;
                        },

                        /**
                         * Converts serialized ciphertext to CipherParams,
                         * else assumed CipherParams already and returns ciphertext unchanged.
                         *
                         * @param {CipherParams|string} ciphertext The ciphertext.
                         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
                         *
                         * @return {CipherParams} The unserialized ciphertext.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
                         */
                        _parse: function (ciphertext, format) {
                            if (typeof ciphertext == 'string') {
                                return format.parse(ciphertext, this);
                            } else {
                                return ciphertext;
                            }
                        }
                    });

                    /**
                     * Key derivation function namespace.
                     */
                    var C_kdf = C.kdf = {};

                    /**
                     * OpenSSL key derivation function.
                     */
                    var OpenSSLKdf = C_kdf.OpenSSL = {
                        /**
                         * Derives a key and IV from a password.
                         *
                         * @param {string} password The password to derive from.
                         * @param {number} keySize The size in words of the key to generate.
                         * @param {number} ivSize The size in words of the IV to generate.
                         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
                         *
                         * @return {CipherParams} A cipher params object with the key, IV, and salt.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
                         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
                         */
                        execute: function (password, keySize, ivSize, salt) {
                            // Generate random salt
                            if (!salt) {
                                salt = WordArray.random(64 / 8);
                            }

                            // Derive key and IV
                            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

                            // Separate key and IV
                            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                            key.sigBytes = keySize * 4;

                            // Return params
                            return CipherParams.create({ key: key, iv: iv, salt: salt });
                        }
                    };

                    /**
                     * A serializable cipher wrapper that derives the key from a password,
                     * and returns ciphertext as a serializable cipher params object.
                     */
                    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
                         */
                        cfg: SerializableCipher.cfg.extend({
                            kdf: OpenSSLKdf
                        }),

                        /**
                         * Encrypts a message using a password.
                         *
                         * @param {Cipher} cipher The cipher algorithm to use.
                         * @param {WordArray|string} message The message to encrypt.
                         * @param {string} password The password.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {CipherParams} A cipher params object.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
                         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
                         */
                        encrypt: function (cipher, message, password, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);

                            // Derive key and other params
                            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

                            // Add IV to config
                            cfg.iv = derivedParams.iv;

                            // Encrypt
                            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

                            // Mix in derived params
                            ciphertext.mixIn(derivedParams);

                            return ciphertext;
                        },

                        /**
                         * Decrypts serialized ciphertext using a password.
                         *
                         * @param {Cipher} cipher The cipher algorithm to use.
                         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                         * @param {string} password The password.
                         * @param {Object} cfg (Optional) The configuration options to use for this operation.
                         *
                         * @return {WordArray} The plaintext.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
                         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
                         */
                        decrypt: function (cipher, ciphertext, password, cfg) {
                            // Apply config defaults
                            cfg = this.cfg.extend(cfg);

                            // Convert string to CipherParams
                            ciphertext = this._parse(ciphertext, cfg.format);

                            // Derive key and other params
                            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

                            // Add IV to config
                            cfg.iv = derivedParams.iv;

                            // Decrypt
                            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

                            return plaintext;
                        }
                    });
                }());


            }));

            /***/
        },
/* 16 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(15));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var WordArray = C_lib.WordArray;
                    var BlockCipher = C_lib.BlockCipher;
                    var C_algo = C.algo;

                    // Permuted Choice 1 constants
                    var PC1 = [
                        57, 49, 41, 33, 25, 17, 9, 1,
                        58, 50, 42, 34, 26, 18, 10, 2,
                        59, 51, 43, 35, 27, 19, 11, 3,
                        60, 52, 44, 36, 63, 55, 47, 39,
                        31, 23, 15, 7, 62, 54, 46, 38,
                        30, 22, 14, 6, 61, 53, 45, 37,
                        29, 21, 13, 5, 28, 20, 12, 4
                    ];

                    // Permuted Choice 2 constants
                    var PC2 = [
                        14, 17, 11, 24, 1, 5,
                        3, 28, 15, 6, 21, 10,
                        23, 19, 12, 4, 26, 8,
                        16, 7, 27, 20, 13, 2,
                        41, 52, 31, 37, 47, 55,
                        30, 40, 51, 45, 33, 48,
                        44, 49, 39, 56, 34, 53,
                        46, 42, 50, 36, 29, 32
                    ];

                    // Cumulative bit shift constants
                    var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

                    // SBOXes and round permutation constants
                    var SBOX_P = [
                        {
                            0x0: 0x808200,
                            0x10000000: 0x8000,
                            0x20000000: 0x808002,
                            0x30000000: 0x2,
                            0x40000000: 0x200,
                            0x50000000: 0x808202,
                            0x60000000: 0x800202,
                            0x70000000: 0x800000,
                            0x80000000: 0x202,
                            0x90000000: 0x800200,
                            0xa0000000: 0x8200,
                            0xb0000000: 0x808000,
                            0xc0000000: 0x8002,
                            0xd0000000: 0x800002,
                            0xe0000000: 0x0,
                            0xf0000000: 0x8202,
                            0x8000000: 0x0,
                            0x18000000: 0x808202,
                            0x28000000: 0x8202,
                            0x38000000: 0x8000,
                            0x48000000: 0x808200,
                            0x58000000: 0x200,
                            0x68000000: 0x808002,
                            0x78000000: 0x2,
                            0x88000000: 0x800200,
                            0x98000000: 0x8200,
                            0xa8000000: 0x808000,
                            0xb8000000: 0x800202,
                            0xc8000000: 0x800002,
                            0xd8000000: 0x8002,
                            0xe8000000: 0x202,
                            0xf8000000: 0x800000,
                            0x1: 0x8000,
                            0x10000001: 0x2,
                            0x20000001: 0x808200,
                            0x30000001: 0x800000,
                            0x40000001: 0x808002,
                            0x50000001: 0x8200,
                            0x60000001: 0x200,
                            0x70000001: 0x800202,
                            0x80000001: 0x808202,
                            0x90000001: 0x808000,
                            0xa0000001: 0x800002,
                            0xb0000001: 0x8202,
                            0xc0000001: 0x202,
                            0xd0000001: 0x800200,
                            0xe0000001: 0x8002,
                            0xf0000001: 0x0,
                            0x8000001: 0x808202,
                            0x18000001: 0x808000,
                            0x28000001: 0x800000,
                            0x38000001: 0x200,
                            0x48000001: 0x8000,
                            0x58000001: 0x800002,
                            0x68000001: 0x2,
                            0x78000001: 0x8202,
                            0x88000001: 0x8002,
                            0x98000001: 0x800202,
                            0xa8000001: 0x202,
                            0xb8000001: 0x808200,
                            0xc8000001: 0x800200,
                            0xd8000001: 0x0,
                            0xe8000001: 0x8200,
                            0xf8000001: 0x808002
                        },
                        {
                            0x0: 0x40084010,
                            0x1000000: 0x4000,
                            0x2000000: 0x80000,
                            0x3000000: 0x40080010,
                            0x4000000: 0x40000010,
                            0x5000000: 0x40084000,
                            0x6000000: 0x40004000,
                            0x7000000: 0x10,
                            0x8000000: 0x84000,
                            0x9000000: 0x40004010,
                            0xa000000: 0x40000000,
                            0xb000000: 0x84010,
                            0xc000000: 0x80010,
                            0xd000000: 0x0,
                            0xe000000: 0x4010,
                            0xf000000: 0x40080000,
                            0x800000: 0x40004000,
                            0x1800000: 0x84010,
                            0x2800000: 0x10,
                            0x3800000: 0x40004010,
                            0x4800000: 0x40084010,
                            0x5800000: 0x40000000,
                            0x6800000: 0x80000,
                            0x7800000: 0x40080010,
                            0x8800000: 0x80010,
                            0x9800000: 0x0,
                            0xa800000: 0x4000,
                            0xb800000: 0x40080000,
                            0xc800000: 0x40000010,
                            0xd800000: 0x84000,
                            0xe800000: 0x40084000,
                            0xf800000: 0x4010,
                            0x10000000: 0x0,
                            0x11000000: 0x40080010,
                            0x12000000: 0x40004010,
                            0x13000000: 0x40084000,
                            0x14000000: 0x40080000,
                            0x15000000: 0x10,
                            0x16000000: 0x84010,
                            0x17000000: 0x4000,
                            0x18000000: 0x4010,
                            0x19000000: 0x80000,
                            0x1a000000: 0x80010,
                            0x1b000000: 0x40000010,
                            0x1c000000: 0x84000,
                            0x1d000000: 0x40004000,
                            0x1e000000: 0x40000000,
                            0x1f000000: 0x40084010,
                            0x10800000: 0x84010,
                            0x11800000: 0x80000,
                            0x12800000: 0x40080000,
                            0x13800000: 0x4000,
                            0x14800000: 0x40004000,
                            0x15800000: 0x40084010,
                            0x16800000: 0x10,
                            0x17800000: 0x40000000,
                            0x18800000: 0x40084000,
                            0x19800000: 0x40000010,
                            0x1a800000: 0x40004010,
                            0x1b800000: 0x80010,
                            0x1c800000: 0x0,
                            0x1d800000: 0x4010,
                            0x1e800000: 0x40080010,
                            0x1f800000: 0x84000
                        },
                        {
                            0x0: 0x104,
                            0x100000: 0x0,
                            0x200000: 0x4000100,
                            0x300000: 0x10104,
                            0x400000: 0x10004,
                            0x500000: 0x4000004,
                            0x600000: 0x4010104,
                            0x700000: 0x4010000,
                            0x800000: 0x4000000,
                            0x900000: 0x4010100,
                            0xa00000: 0x10100,
                            0xb00000: 0x4010004,
                            0xc00000: 0x4000104,
                            0xd00000: 0x10000,
                            0xe00000: 0x4,
                            0xf00000: 0x100,
                            0x80000: 0x4010100,
                            0x180000: 0x4010004,
                            0x280000: 0x0,
                            0x380000: 0x4000100,
                            0x480000: 0x4000004,
                            0x580000: 0x10000,
                            0x680000: 0x10004,
                            0x780000: 0x104,
                            0x880000: 0x4,
                            0x980000: 0x100,
                            0xa80000: 0x4010000,
                            0xb80000: 0x10104,
                            0xc80000: 0x10100,
                            0xd80000: 0x4000104,
                            0xe80000: 0x4010104,
                            0xf80000: 0x4000000,
                            0x1000000: 0x4010100,
                            0x1100000: 0x10004,
                            0x1200000: 0x10000,
                            0x1300000: 0x4000100,
                            0x1400000: 0x100,
                            0x1500000: 0x4010104,
                            0x1600000: 0x4000004,
                            0x1700000: 0x0,
                            0x1800000: 0x4000104,
                            0x1900000: 0x4000000,
                            0x1a00000: 0x4,
                            0x1b00000: 0x10100,
                            0x1c00000: 0x4010000,
                            0x1d00000: 0x104,
                            0x1e00000: 0x10104,
                            0x1f00000: 0x4010004,
                            0x1080000: 0x4000000,
                            0x1180000: 0x104,
                            0x1280000: 0x4010100,
                            0x1380000: 0x0,
                            0x1480000: 0x10004,
                            0x1580000: 0x4000100,
                            0x1680000: 0x100,
                            0x1780000: 0x4010004,
                            0x1880000: 0x10000,
                            0x1980000: 0x4010104,
                            0x1a80000: 0x10104,
                            0x1b80000: 0x4000004,
                            0x1c80000: 0x4000104,
                            0x1d80000: 0x4010000,
                            0x1e80000: 0x4,
                            0x1f80000: 0x10100
                        },
                        {
                            0x0: 0x80401000,
                            0x10000: 0x80001040,
                            0x20000: 0x401040,
                            0x30000: 0x80400000,
                            0x40000: 0x0,
                            0x50000: 0x401000,
                            0x60000: 0x80000040,
                            0x70000: 0x400040,
                            0x80000: 0x80000000,
                            0x90000: 0x400000,
                            0xa0000: 0x40,
                            0xb0000: 0x80001000,
                            0xc0000: 0x80400040,
                            0xd0000: 0x1040,
                            0xe0000: 0x1000,
                            0xf0000: 0x80401040,
                            0x8000: 0x80001040,
                            0x18000: 0x40,
                            0x28000: 0x80400040,
                            0x38000: 0x80001000,
                            0x48000: 0x401000,
                            0x58000: 0x80401040,
                            0x68000: 0x0,
                            0x78000: 0x80400000,
                            0x88000: 0x1000,
                            0x98000: 0x80401000,
                            0xa8000: 0x400000,
                            0xb8000: 0x1040,
                            0xc8000: 0x80000000,
                            0xd8000: 0x400040,
                            0xe8000: 0x401040,
                            0xf8000: 0x80000040,
                            0x100000: 0x400040,
                            0x110000: 0x401000,
                            0x120000: 0x80000040,
                            0x130000: 0x0,
                            0x140000: 0x1040,
                            0x150000: 0x80400040,
                            0x160000: 0x80401000,
                            0x170000: 0x80001040,
                            0x180000: 0x80401040,
                            0x190000: 0x80000000,
                            0x1a0000: 0x80400000,
                            0x1b0000: 0x401040,
                            0x1c0000: 0x80001000,
                            0x1d0000: 0x400000,
                            0x1e0000: 0x40,
                            0x1f0000: 0x1000,
                            0x108000: 0x80400000,
                            0x118000: 0x80401040,
                            0x128000: 0x0,
                            0x138000: 0x401000,
                            0x148000: 0x400040,
                            0x158000: 0x80000000,
                            0x168000: 0x80001040,
                            0x178000: 0x40,
                            0x188000: 0x80000040,
                            0x198000: 0x1000,
                            0x1a8000: 0x80001000,
                            0x1b8000: 0x80400040,
                            0x1c8000: 0x1040,
                            0x1d8000: 0x80401000,
                            0x1e8000: 0x400000,
                            0x1f8000: 0x401040
                        },
                        {
                            0x0: 0x80,
                            0x1000: 0x1040000,
                            0x2000: 0x40000,
                            0x3000: 0x20000000,
                            0x4000: 0x20040080,
                            0x5000: 0x1000080,
                            0x6000: 0x21000080,
                            0x7000: 0x40080,
                            0x8000: 0x1000000,
                            0x9000: 0x20040000,
                            0xa000: 0x20000080,
                            0xb000: 0x21040080,
                            0xc000: 0x21040000,
                            0xd000: 0x0,
                            0xe000: 0x1040080,
                            0xf000: 0x21000000,
                            0x800: 0x1040080,
                            0x1800: 0x21000080,
                            0x2800: 0x80,
                            0x3800: 0x1040000,
                            0x4800: 0x40000,
                            0x5800: 0x20040080,
                            0x6800: 0x21040000,
                            0x7800: 0x20000000,
                            0x8800: 0x20040000,
                            0x9800: 0x0,
                            0xa800: 0x21040080,
                            0xb800: 0x1000080,
                            0xc800: 0x20000080,
                            0xd800: 0x21000000,
                            0xe800: 0x1000000,
                            0xf800: 0x40080,
                            0x10000: 0x40000,
                            0x11000: 0x80,
                            0x12000: 0x20000000,
                            0x13000: 0x21000080,
                            0x14000: 0x1000080,
                            0x15000: 0x21040000,
                            0x16000: 0x20040080,
                            0x17000: 0x1000000,
                            0x18000: 0x21040080,
                            0x19000: 0x21000000,
                            0x1a000: 0x1040000,
                            0x1b000: 0x20040000,
                            0x1c000: 0x40080,
                            0x1d000: 0x20000080,
                            0x1e000: 0x0,
                            0x1f000: 0x1040080,
                            0x10800: 0x21000080,
                            0x11800: 0x1000000,
                            0x12800: 0x1040000,
                            0x13800: 0x20040080,
                            0x14800: 0x20000000,
                            0x15800: 0x1040080,
                            0x16800: 0x80,
                            0x17800: 0x21040000,
                            0x18800: 0x40080,
                            0x19800: 0x21040080,
                            0x1a800: 0x0,
                            0x1b800: 0x21000000,
                            0x1c800: 0x1000080,
                            0x1d800: 0x40000,
                            0x1e800: 0x20040000,
                            0x1f800: 0x20000080
                        },
                        {
                            0x0: 0x10000008,
                            0x100: 0x2000,
                            0x200: 0x10200000,
                            0x300: 0x10202008,
                            0x400: 0x10002000,
                            0x500: 0x200000,
                            0x600: 0x200008,
                            0x700: 0x10000000,
                            0x800: 0x0,
                            0x900: 0x10002008,
                            0xa00: 0x202000,
                            0xb00: 0x8,
                            0xc00: 0x10200008,
                            0xd00: 0x202008,
                            0xe00: 0x2008,
                            0xf00: 0x10202000,
                            0x80: 0x10200000,
                            0x180: 0x10202008,
                            0x280: 0x8,
                            0x380: 0x200000,
                            0x480: 0x202008,
                            0x580: 0x10000008,
                            0x680: 0x10002000,
                            0x780: 0x2008,
                            0x880: 0x200008,
                            0x980: 0x2000,
                            0xa80: 0x10002008,
                            0xb80: 0x10200008,
                            0xc80: 0x0,
                            0xd80: 0x10202000,
                            0xe80: 0x202000,
                            0xf80: 0x10000000,
                            0x1000: 0x10002000,
                            0x1100: 0x10200008,
                            0x1200: 0x10202008,
                            0x1300: 0x2008,
                            0x1400: 0x200000,
                            0x1500: 0x10000000,
                            0x1600: 0x10000008,
                            0x1700: 0x202000,
                            0x1800: 0x202008,
                            0x1900: 0x0,
                            0x1a00: 0x8,
                            0x1b00: 0x10200000,
                            0x1c00: 0x2000,
                            0x1d00: 0x10002008,
                            0x1e00: 0x10202000,
                            0x1f00: 0x200008,
                            0x1080: 0x8,
                            0x1180: 0x202000,
                            0x1280: 0x200000,
                            0x1380: 0x10000008,
                            0x1480: 0x10002000,
                            0x1580: 0x2008,
                            0x1680: 0x10202008,
                            0x1780: 0x10200000,
                            0x1880: 0x10202000,
                            0x1980: 0x10200008,
                            0x1a80: 0x2000,
                            0x1b80: 0x202008,
                            0x1c80: 0x200008,
                            0x1d80: 0x0,
                            0x1e80: 0x10000000,
                            0x1f80: 0x10002008
                        },
                        {
                            0x0: 0x100000,
                            0x10: 0x2000401,
                            0x20: 0x400,
                            0x30: 0x100401,
                            0x40: 0x2100401,
                            0x50: 0x0,
                            0x60: 0x1,
                            0x70: 0x2100001,
                            0x80: 0x2000400,
                            0x90: 0x100001,
                            0xa0: 0x2000001,
                            0xb0: 0x2100400,
                            0xc0: 0x2100000,
                            0xd0: 0x401,
                            0xe0: 0x100400,
                            0xf0: 0x2000000,
                            0x8: 0x2100001,
                            0x18: 0x0,
                            0x28: 0x2000401,
                            0x38: 0x2100400,
                            0x48: 0x100000,
                            0x58: 0x2000001,
                            0x68: 0x2000000,
                            0x78: 0x401,
                            0x88: 0x100401,
                            0x98: 0x2000400,
                            0xa8: 0x2100000,
                            0xb8: 0x100001,
                            0xc8: 0x400,
                            0xd8: 0x2100401,
                            0xe8: 0x1,
                            0xf8: 0x100400,
                            0x100: 0x2000000,
                            0x110: 0x100000,
                            0x120: 0x2000401,
                            0x130: 0x2100001,
                            0x140: 0x100001,
                            0x150: 0x2000400,
                            0x160: 0x2100400,
                            0x170: 0x100401,
                            0x180: 0x401,
                            0x190: 0x2100401,
                            0x1a0: 0x100400,
                            0x1b0: 0x1,
                            0x1c0: 0x0,
                            0x1d0: 0x2100000,
                            0x1e0: 0x2000001,
                            0x1f0: 0x400,
                            0x108: 0x100400,
                            0x118: 0x2000401,
                            0x128: 0x2100001,
                            0x138: 0x1,
                            0x148: 0x2000000,
                            0x158: 0x100000,
                            0x168: 0x401,
                            0x178: 0x2100400,
                            0x188: 0x2000001,
                            0x198: 0x2100000,
                            0x1a8: 0x0,
                            0x1b8: 0x2100401,
                            0x1c8: 0x100401,
                            0x1d8: 0x400,
                            0x1e8: 0x2000400,
                            0x1f8: 0x100001
                        },
                        {
                            0x0: 0x8000820,
                            0x1: 0x20000,
                            0x2: 0x8000000,
                            0x3: 0x20,
                            0x4: 0x20020,
                            0x5: 0x8020820,
                            0x6: 0x8020800,
                            0x7: 0x800,
                            0x8: 0x8020000,
                            0x9: 0x8000800,
                            0xa: 0x20800,
                            0xb: 0x8020020,
                            0xc: 0x820,
                            0xd: 0x0,
                            0xe: 0x8000020,
                            0xf: 0x20820,
                            0x80000000: 0x800,
                            0x80000001: 0x8020820,
                            0x80000002: 0x8000820,
                            0x80000003: 0x8000000,
                            0x80000004: 0x8020000,
                            0x80000005: 0x20800,
                            0x80000006: 0x20820,
                            0x80000007: 0x20,
                            0x80000008: 0x8000020,
                            0x80000009: 0x820,
                            0x8000000a: 0x20020,
                            0x8000000b: 0x8020800,
                            0x8000000c: 0x0,
                            0x8000000d: 0x8020020,
                            0x8000000e: 0x8000800,
                            0x8000000f: 0x20000,
                            0x10: 0x20820,
                            0x11: 0x8020800,
                            0x12: 0x20,
                            0x13: 0x800,
                            0x14: 0x8000800,
                            0x15: 0x8000020,
                            0x16: 0x8020020,
                            0x17: 0x20000,
                            0x18: 0x0,
                            0x19: 0x20020,
                            0x1a: 0x8020000,
                            0x1b: 0x8000820,
                            0x1c: 0x8020820,
                            0x1d: 0x20800,
                            0x1e: 0x820,
                            0x1f: 0x8000000,
                            0x80000010: 0x20000,
                            0x80000011: 0x800,
                            0x80000012: 0x8020020,
                            0x80000013: 0x20820,
                            0x80000014: 0x20,
                            0x80000015: 0x8020000,
                            0x80000016: 0x8000000,
                            0x80000017: 0x8000820,
                            0x80000018: 0x8020820,
                            0x80000019: 0x8000020,
                            0x8000001a: 0x8000800,
                            0x8000001b: 0x0,
                            0x8000001c: 0x20800,
                            0x8000001d: 0x820,
                            0x8000001e: 0x20020,
                            0x8000001f: 0x8020800
                        }
                    ];

                    // Masks that select the SBOX input
                    var SBOX_MASK = [
                        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
                        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
                    ];

                    /**
                     * DES block cipher algorithm.
                     */
                    var DES = C_algo.DES = BlockCipher.extend({
                        _doReset: function () {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;

                            // Select 56 bits according to PC1
                            var keyBits = [];
                            for (var i = 0; i < 56; i++) {
                                var keyBitPos = PC1[i] - 1;
                                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
                            }

                            // Assemble 16 subkeys
                            var subKeys = this._subKeys = [];
                            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
                                // Create subkey
                                var subKey = subKeys[nSubKey] = [];

                                // Shortcut
                                var bitShift = BIT_SHIFTS[nSubKey];

                                // Select 48 bits according to PC2
                                for (var i = 0; i < 24; i++) {
                                    // Select from the left 28 key bits
                                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

                                    // Select from the right 28 key bits
                                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
                                }

                                // Since each subkey is applied to an expanded 32-bit input,
                                // the subkey can be broken into 8 values scaled to 32-bits,
                                // which allows the key to be used without expansion
                                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
                                for (var i = 1; i < 7; i++) {
                                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
                                }
                                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
                            }

                            // Compute inverse subkeys
                            var invSubKeys = this._invSubKeys = [];
                            for (var i = 0; i < 16; i++) {
                                invSubKeys[i] = subKeys[15 - i];
                            }
                        },

                        encryptBlock: function (M, offset) {
                            this._doCryptBlock(M, offset, this._subKeys);
                        },

                        decryptBlock: function (M, offset) {
                            this._doCryptBlock(M, offset, this._invSubKeys);
                        },

                        _doCryptBlock: function (M, offset, subKeys) {
                            // Get input
                            this._lBlock = M[offset];
                            this._rBlock = M[offset + 1];

                            // Initial permutation
                            exchangeLR.call(this, 4, 0x0f0f0f0f);
                            exchangeLR.call(this, 16, 0x0000ffff);
                            exchangeRL.call(this, 2, 0x33333333);
                            exchangeRL.call(this, 8, 0x00ff00ff);
                            exchangeLR.call(this, 1, 0x55555555);

                            // Rounds
                            for (var round = 0; round < 16; round++) {
                                // Shortcuts
                                var subKey = subKeys[round];
                                var lBlock = this._lBlock;
                                var rBlock = this._rBlock;

                                // Feistel function
                                var f = 0;
                                for (var i = 0; i < 8; i++) {
                                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                                }
                                this._lBlock = rBlock;
                                this._rBlock = lBlock ^ f;
                            }

                            // Undo swap from last round
                            var t = this._lBlock;
                            this._lBlock = this._rBlock;
                            this._rBlock = t;

                            // Final permutation
                            exchangeLR.call(this, 1, 0x55555555);
                            exchangeRL.call(this, 8, 0x00ff00ff);
                            exchangeRL.call(this, 2, 0x33333333);
                            exchangeLR.call(this, 16, 0x0000ffff);
                            exchangeLR.call(this, 4, 0x0f0f0f0f);

                            // Set output
                            M[offset] = this._lBlock;
                            M[offset + 1] = this._rBlock;
                        },

                        keySize: 64 / 32,

                        ivSize: 64 / 32,

                        blockSize: 64 / 32
                    });

                    // Swap bits across the left and right words
                    function exchangeLR(offset, mask) {
                        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
                        this._rBlock ^= t;
                        this._lBlock ^= t << offset;
                    }

                    function exchangeRL(offset, mask) {
                        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
                        this._lBlock ^= t;
                        this._rBlock ^= t << offset;
                    }

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
                     */
                    C.DES = BlockCipher._createHelper(DES);

                    /**
                     * Triple-DES block cipher algorithm.
                     */
                    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
                        _doReset: function () {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;

                            // Create DES instances
                            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
                            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
                            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
                        },

                        encryptBlock: function (M, offset) {
                            this._des1.encryptBlock(M, offset);
                            this._des2.decryptBlock(M, offset);
                            this._des3.encryptBlock(M, offset);
                        },

                        decryptBlock: function (M, offset) {
                            this._des3.decryptBlock(M, offset);
                            this._des2.encryptBlock(M, offset);
                            this._des1.decryptBlock(M, offset);
                        },

                        keySize: 192 / 32,

                        ivSize: 64 / 32,

                        blockSize: 64 / 32
                    });

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
                     */
                    C.TripleDES = BlockCipher._createHelper(TripleDES);
                }());


                return CryptoJS.TripleDES;

            }));

            /***/
        },
/* 17 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(15));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var StreamCipher = C_lib.StreamCipher;
                    var C_algo = C.algo;

                    // Reusable objects
                    var S = [];
                    var C_ = [];
                    var G = [];

                    /**
                     * Rabbit stream cipher algorithm
                     */
                    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
                        _doReset: function () {
                            // Shortcuts
                            var K = this._key.words;
                            var iv = this.cfg.iv;

                            // Swap endian
                            for (var i = 0; i < 4; i++) {
                                K[i] = (((K[i] << 8) | (K[i] >>> 24)) & 0x00ff00ff) |
                                    (((K[i] << 24) | (K[i] >>> 8)) & 0xff00ff00);
                            }

                            // Generate initial state values
                            var X = this._X = [
                                K[0], (K[3] << 16) | (K[2] >>> 16),
                                K[1], (K[0] << 16) | (K[3] >>> 16),
                                K[2], (K[1] << 16) | (K[0] >>> 16),
                                K[3], (K[2] << 16) | (K[1] >>> 16)
                            ];

                            // Generate initial counter values
                            var C = this._C = [
                                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
                                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
                                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
                                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
                            ];

                            // Carry bit
                            this._b = 0;

                            // Iterate the system four times
                            for (var i = 0; i < 4; i++) {
                                nextState.call(this);
                            }

                            // Modify the counters
                            for (var i = 0; i < 8; i++) {
                                C[i] ^= X[(i + 4) & 7];
                            }

                            // IV setup
                            if (iv) {
                                // Shortcuts
                                var IV = iv.words;
                                var IV_0 = IV[0];
                                var IV_1 = IV[1];

                                // Generate four subvectors
                                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
                                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
                                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
                                var i3 = (i2 << 16) | (i0 & 0x0000ffff);

                                // Modify counter values
                                C[0] ^= i0;
                                C[1] ^= i1;
                                C[2] ^= i2;
                                C[3] ^= i3;
                                C[4] ^= i0;
                                C[5] ^= i1;
                                C[6] ^= i2;
                                C[7] ^= i3;

                                // Iterate the system four times
                                for (var i = 0; i < 4; i++) {
                                    nextState.call(this);
                                }
                            }
                        },

                        _doProcessBlock: function (M, offset) {
                            // Shortcut
                            var X = this._X;

                            // Iterate the system
                            nextState.call(this);

                            // Generate four keystream words
                            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
                            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
                            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
                            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

                            for (var i = 0; i < 4; i++) {
                                // Swap endian
                                S[i] = (((S[i] << 8) | (S[i] >>> 24)) & 0x00ff00ff) |
                                    (((S[i] << 24) | (S[i] >>> 8)) & 0xff00ff00);

                                // Encrypt
                                M[offset + i] ^= S[i];
                            }
                        },

                        blockSize: 128 / 32,

                        ivSize: 64 / 32
                    });

                    function nextState() {
                        // Shortcuts
                        var X = this._X;
                        var C = this._C;

                        // Save old counter values
                        for (var i = 0; i < 8; i++) {
                            C_[i] = C[i];
                        }

                        // Calculate new counter values
                        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
                        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
                        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
                        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
                        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
                        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
                        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
                        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
                        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

                        // Calculate the g-values
                        for (var i = 0; i < 8; i++) {
                            var gx = X[i] + C[i];

                            // Construct high and low argument for squaring
                            var ga = gx & 0xffff;
                            var gb = gx >>> 16;

                            // Calculate high and low result of squaring
                            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
                            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

                            // High XOR low
                            G[i] = gh ^ gl;
                        }

                        // Calculate new state values
                        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
                        X[1] = (G[1] + ((G[0] << 8) | (G[0] >>> 24)) + G[7]) | 0;
                        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
                        X[3] = (G[3] + ((G[2] << 8) | (G[2] >>> 24)) + G[1]) | 0;
                        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
                        X[5] = (G[5] + ((G[4] << 8) | (G[4] >>> 24)) + G[3]) | 0;
                        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
                        X[7] = (G[7] + ((G[6] << 8) | (G[6] >>> 24)) + G[5]) | 0;
                    }

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
                     */
                    C.Rabbit = StreamCipher._createHelper(Rabbit);
                }());


                return CryptoJS.Rabbit;

            }));

            /***/
        },
/* 18 */
/***/ function (module, exports, __webpack_require__) {

            ; (function (root, factory, undef) {
                if (true) {
                    // CommonJS
                    module.exports = exports = factory(__webpack_require__(5), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(15));
                }
                else if (typeof define === "function" && define.amd) {
                    // AMD
                    define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
                }
                else {
                    // Global (browser)
                    factory(root.CryptoJS);
                }
            }(this, function (CryptoJS) {

                (function () {
                    // Shortcuts
                    var C = CryptoJS;
                    var C_lib = C.lib;
                    var StreamCipher = C_lib.StreamCipher;
                    var C_algo = C.algo;

                    /**
                     * RC4 stream cipher algorithm.
                     */
                    var RC4 = C_algo.RC4 = StreamCipher.extend({
                        _doReset: function () {
                            // Shortcuts
                            var key = this._key;
                            var keyWords = key.words;
                            var keySigBytes = key.sigBytes;

                            // Init sbox
                            var S = this._S = [];
                            for (var i = 0; i < 256; i++) {
                                S[i] = i;
                            }

                            // Key setup
                            for (var i = 0, j = 0; i < 256; i++) {
                                var keyByteIndex = i % keySigBytes;
                                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

                                j = (j + S[i] + keyByte) % 256;

                                // Swap
                                var t = S[i];
                                S[i] = S[j];
                                S[j] = t;
                            }

                            // Counters
                            this._i = this._j = 0;
                        },

                        _doProcessBlock: function (M, offset) {
                            M[offset] ^= generateKeystreamWord.call(this);
                        },

                        keySize: 256 / 32,

                        ivSize: 0
                    });

                    function generateKeystreamWord() {
                        // Shortcuts
                        var S = this._S;
                        var i = this._i;
                        var j = this._j;

                        // Generate keystream word
                        var keystreamWord = 0;
                        for (var n = 0; n < 4; n++) {
                            i = (i + 1) % 256;
                            j = (j + S[i]) % 256;

                            // Swap
                            var t = S[i];
                            S[i] = S[j];
                            S[j] = t;

                            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
                        }

                        // Update counters
                        this._i = i;
                        this._j = j;

                        return keystreamWord;
                    }

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
                     */
                    C.RC4 = StreamCipher._createHelper(RC4);

                    /**
                     * Modified RC4 stream cipher algorithm.
                     */
                    var RC4Drop = C_algo.RC4Drop = RC4.extend({
                        /**
                         * Configuration options.
                         *
                         * @property {number} drop The number of keystream words to drop. Default 192
                         */
                        cfg: RC4.cfg.extend({
                            drop: 192
                        }),

                        _doReset: function () {
                            RC4._doReset.call(this);

                            // Drop
                            for (var i = this.cfg.drop; i > 0; i--) {
                                generateKeystreamWord.call(this);
                            }
                        }
                    });

                    /**
                     * Shortcut functions to the cipher's object interface.
                     *
                     * @example
                     *
                     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
                     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
                     */
                    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
                }());


                return CryptoJS.RC4;

            }));

            /***/
        }
/******/])
});
;
//# sourceMappingURL=secure-ls.js.map
/* eslint-disable */